/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-mixed-operators */
/* eslint-disable eqeqeq */
import React, { Component } from "react";

import "./custompayslip.css";
import axios from "axios";
import { connect } from "react-redux";
import API_URL from "../../constants/API_URL";
import Timer from "../POS/Timer";
import "antd/dist/antd.css";
import {
  Button,
  Card,
  Icon,
  Modal,
  Input,
  Select,
  message,
  Row,
  Col,
  InputNumber,
  Radio,
  Checkbox,
  Form,
  Popover,
} from "antd";
import { AiOutlineStop } from "react-icons/ai";
import {
  FaCheckCircle,
  FaRegAddressCard,
  FaTrash,
  FaWindowClose,
} from "react-icons/fa";
import { Switch } from "antd";
import MyImg from "../POS/MyImg";
import { BsThreeDots } from "react-icons/bs";
import { RiCashFill } from "react-icons/ri";
import Swal from "sweetalert2";

window.addEventListener("load", () => {
  let inp = document.getElementById("barcodeinput");
  if (inp) {
    inp.blur();
  }
});

const initialState = {
  visible: false,
  totalOrder: {},
  popoverVisible: false,
  visible2: false,
  combosList: [],
  isCustomerSelect: false,
  selectedOrderLine: "",
  selectedOrderLineProduct: "",
  selectedOrderLineUom: "",
  comboProductsModal: false,
  comboProductsModalUpdate: false,
  comboProductForUpdate: {},
  selectedOrderLineUnitPrice: "",
  selectedOrderLinePrevious: "",
  qtyPrevous: "",
  note: "",
  parameters: [],
  deletedComboLines: [],
  paymethods: [],
  modalType: "",
  payment: "",
  orderId: "",
  selectedqty: "",
  additionalProduct: [],
  isGroupProduct: false,
  productsListByClient: [],
  comboDetailOptionForUpdate: [],
  refunModal: false,
  refundObject: {},
  refundQTY: 0,
  cancel: false,
  addedAdditionalItems: [],
  addedAdditionalItemsParent: {},
  visibleOkButton: true,
  amountPay: "",
  combo: {},
  notesForKitchen: null,
  notesForKitchenParentLine: null,
  isNotesForKitchenParentLine: false,
  amountPaycheck: "",
  isModalOpenForKitchenNotes: false,
  isNotesAddedOnCreate: false,
  saleOrderTobaccoByOrder: null,
  isNotesAddedOnCreateParent: false,
  setmapindex: 0,
  setisactive: 0,
  inputval: "",
  barcodeinput: "",
  loadingBtnAddProduct: false,
};

class Poslip extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.focus = this.focus.bind(this);
  }

  EmptyUserObj = () => {
    this.props.EmptyUserObjMain();
  };
  modalOpenForKitchenNotesHandleer = () => {
    if (this.state.isNotesAddedOnCreate) {
      if (this.state.isNotesAddedOnCreateParent) {
        let addedAdditionalItemsParent = {
          ...this.state.addedAdditionalItemsParent,
        };
        addedAdditionalItemsParent.notes = this.state.notesForKitchen;
        this.setState({ addedAdditionalItemsParent }, () => {
          this.setState({
            isNotesAddedOnCreate: false,
            isNotesAddedOnCreateParent: false,
            isModalOpenForKitchenNotes: false,
            // notesForKitchen: null,
          });
        });
      } else {
        let addedAdditionalItems = [...this.state.addedAdditionalItems];
        if (addedAdditionalItems.length > 0) {
          let index = addedAdditionalItems.findIndex(
            (item) => item.product == this.state.itemSelectedForNotesKitchen,
          );
          addedAdditionalItems[index].notes = this.state.notesForKitchen;
          this.setState({ addedAdditionalItems }, () => {
            this.setState({
              isNotesAddedOnCreate: false,
              isModalOpenForKitchenNotes: false,
              // notesForKitchen: null,
            });
          });
        }
      }
    } else {
      if (this.state.isNotesForKitchenParentLine) {
        this.setState({ isModalOpenForKitchenNotes: false });
      } else {
        let item = { ...this.state.itemSelectedForNotesKitchen };
        item.notes = this.state.notesForKitchen;
        item.lang = localStorage.getItem("lang");
        let data = { ...item };

        let authOptions = {
          url: API_URL + "updateSaleOrderLine",
          method: "POST",
          data: data,
          headers: {
            Authorization:
              localStorage.getItem("tokenType") +
              " " +
              localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        };
        axios(authOptions)
          .then((res) => {
            if (res.data.success) {
              this.setState({ isModalOpenForKitchenNotes: false });
              message.success(res.data.message);
              this.props.getsaleOrderLine();
            } else {
              message.error(res.data.message);
            }
          })
          .catch((err) => {});
      }
    }
  };
  myRset = () => {
    this.setState(initialState, () => {
      this.getcombosList();
      axios({
        method: "GET",
        url: API_URL + "productsListByClient",
        params: {
          clientId: localStorage.getItem("clientId"),
          lang: localStorage.getItem("lang"),
        },
        headers: {
          Authorization:
            localStorage.getItem("tokenType") +
            " " +
            localStorage.getItem("accessToken"),
          "Content-Type": "application/json",
        },
      }).then((res) => {
        this.setState({ productsListByClient: res.data });
      });

      this.setState({
        orderId: this.props.posStorage.orderId,
        customer: this.props.posStorage.customer,
        floorId: this.props.posStorage.floorId,
      });
      let self = this;
      let headers = {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      };
      var authOptions = {
        method: "GET",
        url: API_URL + "parametersListByParaType",
        params: {
          paraType: "PRIORITY",
          lang: localStorage.getItem("lang"),
        },
        headers,
      };
      axios(authOptions)
        .then(function(response) {
          self.setState({
            parameters: response.data,
          });
        })
        .catch(function(error) {
          //message.error(error.response.data.message);
        });

      authOptions = {
        method: "GET",
        url: API_URL + "branchPayMethodsList",
        params: {
          branchId: JSON.parse(localStorage.getItem("userData")).branchId,
          lang: localStorage.getItem("lang"),
        },
        headers,
      };
      axios(authOptions)
        .then((res) => {
          this.setState({ paymethods: res.data });
        })
        .catch((err) => {});
      setTimeout(() => {
        var objDiv = document.getElementById("style-13");
        if (objDiv) {
          objDiv.scrollTop = objDiv.scrollHeight;
        }
      }, 3000);
    });
  };
  componentDidMount() {
    // setTimeout(() => {
    //   this.focus();
    // }, 100);

    this.getcombosList();
    this.saleOrderTobaccoByOrder();
    axios({
      method: "GET",
      url: API_URL + "productsListByClient",
      params: {
        clientId: localStorage.getItem("clientId"),
        lang: localStorage.getItem("lang"),
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    }).then((res) => {
      this.setState({ productsListByClient: res.data });
    });

    this.setState({
      orderId: this.props.posStorage.orderId,
      customer: this.props.posStorage.customer,
      floorId: this.props.posStorage.floorId,
    });
    let self = this;
    let headers = {
      Authorization:
        localStorage.getItem("tokenType") +
        " " +
        localStorage.getItem("accessToken"),
      "Content-Type": "application/json",
    };
    var authOptions = {
      method: "GET",
      url: API_URL + "parametersListByParaType",
      params: {
        paraType: "PRIORITY",
        lang: localStorage.getItem("lang"),
      },
      headers,
    };
    axios(authOptions)
      .then(function(response) {
        self.setState({
          parameters: response.data,
        });
      })
      .catch(function(error) {
        //message.error(error.response.data.message);
      });

    authOptions = {
      method: "GET",
      url: API_URL + "branchPayMethodsList",
      params: {
        branchId: JSON.parse(localStorage.getItem("userData")).branchId,
        lang: localStorage.getItem("lang"),
      },
      headers,
    };
    axios(authOptions)
      .then((res) => {
        this.setState({ paymethods: res.data });
      })
      .catch((err) => {});
    setTimeout(() => {
      var objDiv = document.getElementById("style-13");
      if (objDiv) {
        objDiv.scrollTop = objDiv.scrollHeight;
      }
      // this.scrollToBottom();
    }, 3000);
  }
  saleOrderTobaccoByOrder = () => {
    if (this.props.posStorage.orderId) {
      let headers = {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      };
      axios({
        method: "GET",
        url: API_URL + "saleOrderTobaccoByOrder",
        params: {
          orderId: this.props.posStorage.orderId,
          lang: localStorage.getItem("lang"),
        },
        headers,
      }).then((res) => {
        if (res.data.success) {
          this.setState({ saleOrderTobaccoByOrder: res.data.object });
          localStorage.setItem(
            "saveSaleOrderTobacco",
            JSON.stringify(res.data.object),
          );
        }
      });
    }
  };
  comboProductsModalOpenFunction = () => {
    let combo = {
      ...this.props.selectedCombo,
      qty: 1,
      total: 0,
      comboLines: [],
    };
    combo.combo = combo.id;
    this.setState({
      comboProductsModal: true,
      combo,
      comboDetailOption: this.props.comboDetailOption,
    });
  };
  getcombosList = () => {
    axios({
      method: "GET",
      url: API_URL + "combosList",
      params: {
        clientId: localStorage.getItem("clientId"),
        lang: localStorage.getItem("lang"),
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    }).then((res) => {
      this.setState({ combosList: res.data });
    });
  };
  refunModalHandler = (orderItem) => {
    let data = {
      lang: localStorage.getItem("lang"),
      id: orderItem.id,
      refundQty: parseInt(this.state.refundQTY),
      cashier: JSON.parse(localStorage.getItem("userData")).userId,
    };
    let headers = {
      Authorization:
        localStorage.getItem("tokenType") +
        " " +
        localStorage.getItem("accessToken"),
      "Content-Type": "application/json",
    };
    let authOptions = {
      url: API_URL + "updateSaleOrderLinetRefundQty",
      method: "POST",
      data,
      headers,
    };
    axios(authOptions).then((res) => {
      // console.log(res)
      if (res.data.success) {
        message.success(res.data.message);
        this.props.getsaleOrderLine();
        this.setState({ refunModal: false });
      } else {
        message.error(res.data.message);
      }
    });
  };
  showModal2 = (e) => {
    let url;
    if (this.state.isGroupProduct) {
      url = API_URL + "groupItemPosProductsByGroupProduct";
    } else {
      url = API_URL + "additionalPosProductsListByProduct";
    }
    axios({
      method: "GET",
      url,
      params: {
        productId: this.state.selectedOrderLineProduct,
        lang: localStorage.getItem("lang"),
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        this.setState({ additionalProduct: res.data });
        // console.log(this.state.selectedOrderLineProduct)
      })
      .catch((err) => {
        // console.log(err)
      });
    this.setState({
      visible2: true,
      modalType: e,
    });
  };
  qtyCalculatorHandler = () => {
    this.setState({
      selectedqty: parseFloat(this.state.amountPay),
      qtyCalculator: false,
    });
  };
  showModal = (e) => {
    let url;
    if (this.state.isGroupProduct) {
      url = API_URL + "groupItemPosProductsByGroupProduct";
    } else {
      url = API_URL + "additionalPosProductsListByProduct";
    }
    axios({
      method: "GET",
      url,
      params: {
        productId: this.state.selectedOrderLineProduct,
        lang: localStorage.getItem("lang"),
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        this.setState({
          additionalProduct: res.data,
          visibleOkButton: this.state.isGroupProduct,
        });
        // console.log(this.state.selectedOrderLineProduct)
      })
      .catch((err) => {
        // console.log(err)
      });
    this.setState({
      visible: true,
      modalType: e,
    });
  };
  handleOk1stModal = async (e) => {
    // document.getElementById('kitchen')?.style?.display = 'block'
    let headers = {
      Authorization:
        localStorage.getItem("tokenType") +
        " " +
        localStorage.getItem("accessToken"),
      "Content-Type": "application/json",
    };

    if (this.state.isGroupProduct) {
      let totalqty = 0;
      let min =
        this.state.addedAdditionalItemsParent.min * this.state.selectedqty;
      let max =
        this.state.addedAdditionalItemsParent.max * this.state.selectedqty;
      this.state.addedAdditionalItems.forEach((product) => {
        totalqty = product.qty + totalqty;
      });
      if (totalqty >= min && totalqty <= max) {
        let dataToSend = { ...this.state.addedAdditionalItemsParent };
        dataToSend.qty = this.state.selectedqty;
        dataToSend.items = [...this.state.addedAdditionalItems];
        let authOptions = {
          url: API_URL + "createGroupProductSaleOrderLine",
          method: "POST",
          data: dataToSend,
          headers,
        };
        // await getsaleOrderLine by othman
        this.setState({ loadingBtnAddProduct: true });
        axios(authOptions)
          .then(async (res) => {
            if (res.data.success) {
              this.setState({ notesForKitchen: null });

              try {
                await this.props.getsaleOrderLine(); // Wait for this function to complete
                console.log("Sale order line fetched successfully!");
              } catch (error) {
                console.error("Error fetching sale order line:", error);
              }
              this.setState({
                visible: false,
                selectedOrderLine: "",
                addedAdditionalItems: [],
              });
              this.setState({ loadingBtnAddProduct: false });
            } else {
              this.setState({ loadingBtnAddProduct: false });
              message.error(res.data.message);
            }
          })
          .catch((err) => {
            this.setState({
              visible: false,
              selectedOrderLine: "",
              addedAdditionalItems: [],
            });
            this.setState({ loadingBtnAddProduct: false });
          });
      } else {
        message.error(
          "Min Quantity should be " + min + " and Max Quantity " + max,
        );
      }
    } else {
      let dataToSend = { ...this.state.addedAdditionalItemsParent };
      dataToSend.actualPrice = dataToSend.unitPrice;
      let up = 0;
      let isDiscount = false;
      let pp = this.props.productList.filter(
        (i) => i.id == dataToSend.product,
      )[0];
      if (JSON.parse(localStorage.getItem("isInclusiveTax"))) {
        up = pp.price;
        if (this.state.selectedOrderLineUnitPrice != up) {
          isDiscount = true;
          dataToSend.unitPrice = this.state.selectedOrderLineUnitPrice;
          dataToSend.priceWithoutTax = this.state.selectedOrderLineUnitPriceWithoutTax;
          dataToSend.unitPriceWithoutTax = this.state.selectedOrderLineUnitPriceWithoutTax;
        }
      } else {
        up = pp.priceWithoutTax;
        if (this.state.selectedOrderLineUnitPriceWithoutTax != up) {
          isDiscount = true;
          dataToSend.unitPriceWithoutTax = this.state.selectedOrderLineUnitPriceWithoutTax;
          dataToSend.priceWithoutTax = this.state.selectedOrderLineUnitPriceWithoutTax;
          dataToSend.unitPrice = this.state.selectedOrderLineUnitPrice;
        }
      }
      dataToSend.isDiscount = isDiscount;
      dataToSend.qty = this.state.selectedqty;
      // return
      dataToSend.items = [...this.state.addedAdditionalItems];
      let authOptions = {
        url: API_URL + "createGroupProductSaleOrderLine",
        method: "POST",
        data: dataToSend,
        headers,
      };
      // await getsaleOrderLine by othman
      this.setState({ loadingBtnAddProduct: true });
      axios(authOptions)
        .then(async (res) => {
          if (res.data.success) {
            this.setState({ notesForKitchen: null });

            try {
              await this.props.getsaleOrderLine(); // Wait for this function to complete
              console.log("Sale order line fetched successfully!");
            } catch (error) {
              console.error("Error fetching sale order line:", error);
            }
            this.setState({
              visible: false,
              selectedOrderLine: "",
              addedAdditionalItems: [],
            });
            this.setState({ loadingBtnAddProduct: false });
          } else {
            this.setState({ loadingBtnAddProduct: false });
            message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.setState({
            visible: false,
            selectedOrderLine: "",
            addedAdditionalItems: [],
          });
          this.setState({ loadingBtnAddProduct: false });
        });
    }
  };
  handleCancel1stModal = (e) => {
    this.removeProductLine();
    if (this.state.modalType.toString() === "poslineAdded") {
      if (this.state.addedAdditionalItems.length > 0) {
        message.warning(this.props.lang.MESSAGES.CLOSE_PRODUCTADDMODAL_ERROR);
      } else {
        this.setState({ visible: false, addedAdditionalItems: [] });
      }
    } else {
      this.setState({ visible: false, addedAdditionalItems: [] });
    }
  };
  handleOk = (e) => {
    if (
      this.state.modalType.toString() == "priority" ||
      this.state.modalType.toString() == "notes"
    ) {
      let headers = {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      };
      let data;
      if (this.state.orderId) {
        axios({
          method: "GET",
          url: API_URL + "saleOrderByID",
          params: {
            id: this.state.orderId,
            lang: localStorage.getItem("lang"),
          },
          headers: {
            Authorization:
              localStorage.getItem("tokenType") +
              " " +
              localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        }).then((res) => {
          if (
            this.state.modalType &&
            this.state.modalType.toString() === "notes"
          ) {
            data = {
              lang: localStorage.getItem("lang"),
              id: this.state.orderId,
              customer: this.state.customer,
              notes: this.state.note,
              orderType: res.data.object.orderType,
              flrTable: this.state.floorId,
            };
          } else if (
            this.state.modalType &&
            this.state.modalType.toString() === "priority"
          ) {
            data = {
              lang: localStorage.getItem("lang"),
              id: this.state.orderId,
              customer: this.state.customer,
              priority: this.state.note,
              orderType: res.data.object.orderType,
              flrTable: this.state.floorId,
            };
          } else if (
            this.state.modalType &&
            this.state.modalType.toString() === "selectPayment"
          ) {
            data = {
              lang: localStorage.getItem("lang"),
              id: this.state.orderId,
              customer: this.state.customer,
              orderType: res.data.object.orderType,
              payMethod: this.state.payment,
              flrTable: this.state.floorId,
            };
          }

          let authOptions = {
            url: API_URL + "updateSaleOrder",
            method: "POST",
            data,
            headers,
          };
          axios(authOptions).then((res) => {
            // console.log('update sale order',res)
            if (res.data.success) {
              this.setState({
                visible2: false,
              });
              // message.success(res.data.message)
            } else {
              message.error(res.data.message);
            }
            // console.log(res)
            // message(res.data.message)
          });
        });
      }
    } else if (this.state.modalType.toString() == "poslineAdded") {
      this.qtyUpdate();
    } else if (this.state.modalType.toString() == "remove" && e) {
      this.setState({ visible2: false, cancel: false });
      this.removeProductLine();
    } else if (this.state.modalType.toString() == "selectPayment") {
      this.setState({ visible2: false });
    } else if (this.state.modalType.toString() == "remove" && !e) {
      this.setState({ visible2: false, cancel: false });
      // this.removeProductLine()
    }
    this.setState({
      additionalProduct: [],
    });
  };

  handleCancel = (e) => {
    //console.log(e);
    this.setState({
      visible2: false,
      visible: false,
      additionalProduct: [],
    });
  };
  removeProductLine = () => {
    let headers = {
      Authorization:
        localStorage.getItem("tokenType") +
        " " +
        localStorage.getItem("accessToken"),
      "Content-Type": "application/json",
    };
    let data = {
      lang: localStorage.getItem("lang"),
      id: this.state.selectedOrderLine,
    };
    let authOptions = {
      url: API_URL + "deleteSaleOrderLine",
      method: "POST",
      data,
      headers,
    };
    axios(authOptions)
      .then((res) => {
        if (res.data.success) {
          this.setState({ visible2: false });
          this.props.getsaleOrderLine();
        }
      })
      .catch();
    // this.setState({ selectedOrderLinePrevious: this.state.selectedOrderLine, })
  };
  isEmpty(obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }

    return JSON.stringify(obj) === JSON.stringify({});
  }
  componentWillReceiveProps() {
    this.saleOrderTobaccoByOrder();
    let tempObj = { ...this.props.totalOrder };

    if (this.props.isDiscount) {
      if (this.props.isDiscountP) {
        let percntgDis =
          (this.props.disPrctg / 100) * this.props.totalOrder.totalNet;
        let temp = Number(this.props.totalOrder.totalNet) - Number(percntgDis);
        tempObj.totalNet = temp;
        let tax = (5 / 100) * temp;
        tempObj.totalWithoutTax = temp - tax;
      } else {
        let temp =
          Number(this.props.totalOrder.totalNet) - Number(this.props.disAmt);
        tempObj.totalNet = temp;
        let tax = (5 / 100) * temp;
        tempObj.totalWithoutTax = temp - tax;
      }
    }
    this.setState({ a: "sadads", totalOrder: { ...tempObj } });
  }
  stateUpdate() {
    this.setState({ a: "adads" });
  }
  qtyUpdate = (e, a) => {
    // console.log(this.props.totalOrder.status)
    let qty = this.state.selectedqty;
    if (this.props.totalOrder.status != "RI") {
      if (
        this.state.selectedOrderLinePrevious === this.state.selectedOrderLine
      ) {
        // qty = this.state.qtyPrevous + qty.toString()
        qty = this.state.selectedqty.toString();
      }
    }
    let headers = {
      Authorization:
        localStorage.getItem("tokenType") +
        " " +
        localStorage.getItem("accessToken"),
      "Content-Type": "application/json",
    };
    let data;
    if (this.props.totalOrder.status == "RI") {
    } else {
      data = {
        lang: localStorage.getItem("lang"),
        id: this.state.selectedOrderLine,
        qty: parseInt(qty),
        product: this.state.selectedOrderLineProduct,
        uom: this.state.selectedOrderLineUom,
        unitPrice: this.state.selectedOrderLineUnitPrice,
        priceWithoutTax: this.state.selectedOrderLineUnitPriceWithoutTax,
        cashier: JSON.parse(localStorage.getItem("userData")).userId,
        notes: this.state.notesForKitchen,
      };
    }
    let authOptions;
    if (this.props.totalOrder.status == "RI") {
    } else {
      if (this.state.isGroupProduct) {
        data.isGroupProduct = true;
      } else {
        data.isGroupProduct = false;
      }
      authOptions = {
        url: API_URL + "updateSaleOrderLine",
        method: "POST",
        data,
        headers,
      };
    }

    axios(authOptions).then((res) => {
      // console.log(res)
      if (res.data.success) {
        // message.success(res.data.message)
        this.setState({ visible2: false });
        this.props.getsaleOrderLine();
      } else {
        message.error(res.data.message);
      }
    });
    this.setState({
      selectedOrderLinePrevious: this.state.selectedOrderLine,
      qtyPrevous: qty,
    });
  };
  scrollToBottom = () => {
    this.messagesEnd &&
      this.messagesEnd.scrollIntoView &&
      this.messagesEnd.scrollIntoView({ behavior: "smooth" });
  };
  sonQTYchange = (v) => {
    if (isNaN(v)) {
    } else {
      if (this.props.totalOrder.status == "RI") {
        // console.log('a')
        if (this.state.refqty < v) {
          // console.log('aa')
          this.setState({ selectedqty: this.state.selectedqty }, () => {
            message.error(this.props.lang.MESSAGES.RETURN_QTY_ERROR);
          });
        } else {
          // console.log('ab')
          this.setState({ selectedqty: v });
        }
      } else {
        // console.log('b')

        this.setState({ selectedqty: v });
      }
    }
  };
  calculatorFunction = (e) => {
    let amountPay = this.state.amountPay;
    // console.log(amountPay, 'amountPay')
    if (e != "b" && e != "c" && e != "e" && e != ".") {
      amountPay = amountPay + e.toString();
      this.setState({
        amountPay: parseFloat(amountPay),
        amountPaycheck: parseFloat(amountPay),
      });
    } else if (
      e == "b" &&
      this.state.amountPay != 0 &&
      this.state.amountPay != ""
    ) {
      amountPay = amountPay.toString();
      if (amountPay.length == 1) {
        amountPay = 0;
        this.setState({
          amountPay: parseFloat(amountPay),
          amountPaycheck: parseFloat(amountPay),
        });
      } else {
        amountPay = amountPay.substring(0, amountPay.length - 1);
        this.setState({
          amountPay: parseFloat(amountPay),
          amountPaycheck: parseFloat(amountPay),
        });
      }
    } else if (e == "c") {
      amountPay = 0;
      this.setState({
        amountPay: parseFloat(amountPay),
        amountPaycheck: parseFloat(amountPay),
      });
    } else if (e == ".") {
      if (this.state.amountPay == 0) {
        amountPay = "0.";
        this.setState({
          amountPay: amountPay,
          amountPaycheck: amountPay,
        });
      } else {
        amountPay = amountPay + ".";
        this.setState({
          amountPay: amountPay,
          amountPaycheck: amountPay,
        });
      }
    } else if (e == "e") {
      this.qtyCalculatorHandler();
    }
  };
  selectComboProduct = (product, e, parentProduct) => {
    let productobj = { ...product };
    productobj.product = product.productId;
    productobj.unitPrice = product.salesPriceTax;
    productobj.priceWithoutTax = product.salesPrice;
    if (e.target.checked) {
      // no of selected product
      let comboDetailOption = this.state.comboDetailOption;
      let index = this.state.comboDetailOption.findIndex(
        (i) => i.id == parentProduct.id,
      );
      if (comboDetailOption[index].noOfSelected) {
        if (comboDetailOption[index].noOfSelected >= parentProduct.maxProduct) {
          message.error(this.props.lang.MESSAGES.MAX_QTY_ERROR);
          return false;
        } else {
          comboDetailOption[index].noOfSelected =
            parseInt(comboDetailOption[index].noOfSelected) + 1;
        }
      } else {
        comboDetailOption[index].noOfSelected = 1;
      }
      let combo = { ...this.state.combo };
      let comboLines = [...this.state.combo.comboLines];
      comboLines.push(productobj);
      combo.total = parseFloat(combo.total) + parseFloat(productobj.unitPrice);
      combo.comboLines = [...comboLines];
      this.setState({ combo, comboDetailOption });
    } else {
      let combo = { ...this.state.combo };
      let comboLines = [...this.state.combo.comboLines];
      comboLines = [...comboLines.filter((i) => i.id != e.target.value)];
      combo.comboLines = [...comboLines];
      combo.total = combo.total - product.salesPriceTax;

      // no of selected product
      let comboDetailOption = this.state.comboDetailOption;
      let index = this.state.comboDetailOption.findIndex(
        (i) => i.id == parentProduct.id,
      );
      if (comboDetailOption[index].noOfSelected) {
        if (comboDetailOption[index].noOfSelected >= parentProduct.maxProduct) {
          comboDetailOption[index].noOfSelected =
            comboDetailOption[index].noOfSelected - 1;
        } else {
          comboDetailOption[index].noOfSelected =
            comboDetailOption[index].noOfSelected - 1;
        }
      } else {
        comboDetailOption[index].noOfSelected = 0;
      }
      this.setState({ combo, comboDetailOption });
    }
  };
  handleComboProductsOnOk = () => {
    // document?.getElementById('kitchen')?.style?.display = 'block'
    let comboDetailOption = this.state.comboDetailOption;
    for (let i = 0; i < comboDetailOption.length; i++) {
      if (comboDetailOption[i].noOfSelected) {
        if (
          comboDetailOption[i].maxProduct >=
            comboDetailOption[i].noOfSelected &&
          comboDetailOption[i].noOfSelected >= comboDetailOption[i].minProduct
        ) {
        } else {
          message.error(this.props.lang.MESSAGES.PRODUCT_SELECTED_QTY_ERROR);
          return false;
        }
      } else {
        message.error(this.props.lang.MESSAGES.PRODUCT_SELECTED_QTY_ERROR);
        return false;
      }
    }

    let data = { ...this.state.combo };
    data.client = localStorage.getItem("clientId");
    data.lang = localStorage.getItem("lang");
    // data.order = JSON.parse(localStorage.getItem('posStorage')).orderId
    data.order = this.props.posStorage.orderId;
    axios({
      url: API_URL + "createSaleOrderComboLine",
      method: "POST",
      data,
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    }).then((res) => {
      if (res.data.success) {
        message.success(res.data.message);
        this.setState(
          { comboProductsModal: false, notesForKitchen: null },
          () => {
            this.props.getsaleOrderLine();
          },
        );
      } else {
        message.error(res.data.message);
      }
    });
  };
  comboProductUpdateOpenHandler = (item) => {
    axios({
      method: "GET",
      url: API_URL + "comboByID",
      params: {
        id: item.combo,
        lang: localStorage.getItem("lang"),
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        let combo = {
          ...res.data.object,
          qty: item.qty,
          total: item.unitPrice,
          comboLines: [
            ...this.props.posProductsLists.filter(
              (i) => i.parentProduct == item.id,
            ),
          ],
        };
        axios({
          url: API_URL + "comboOptionDetailsByCombo",
          method: "GET",
          headers: {
            Authorization:
              localStorage.getItem("tokenType") +
              " " +
              localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
          params: {
            comboId: item.combo,
            lang: localStorage.getItem("lang"),
          },
        }).then((result) => {
          this.setState({
            comboProductsModalUpdate: true,
            combo,
            comboDetailOptionForUpdate: result.data,
            updatingComboId: item.id,
          });
        });
      })
      .catch((err) => {});
  };
  selectComboProductUpdate = (product, e, parentProduct) => {
    let productobj = { ...product };
    productobj.product = product.productId;
    productobj.unitPrice = product.salesPriceTax;
    let selectedItems = 0;
    for (let j = 0; j < parentProduct.products.length; j++) {
      if (
        this.state.combo.comboLines.filter(
          (i) => i.product == parentProduct.products[j].productId,
        ).length > 0
      ) {
        selectedItems = selectedItems + 1;
      }
    }
    if (e.target.checked) {
      // no of selected product
      let comboDetailOptionForUpdate = this.state.comboDetailOptionForUpdate;
      let index = this.state.comboDetailOptionForUpdate.findIndex(
        (i) => i.id == parentProduct.id,
      );
      comboDetailOptionForUpdate[index].noOfSelected = selectedItems;
      if (comboDetailOptionForUpdate[index].noOfSelected) {
        if (
          comboDetailOptionForUpdate[index].noOfSelected >=
          parentProduct.maxProduct
        ) {
          message.error(this.props.lang.MESSAGES.MAX_QTY_ERROR);
          return false;
        } else {
          comboDetailOptionForUpdate[index].noOfSelected =
            parseInt(comboDetailOptionForUpdate[index].noOfSelected) + 1;
        }
      } else {
        comboDetailOptionForUpdate[index].noOfSelected = 1;
      }
      let combo = { ...this.state.combo };
      let comboLines = [...this.state.combo.comboLines];
      productobj.action = "N";
      comboLines.push(productobj);

      let deletedComboLines = [...this.state.deletedComboLines];
      deletedComboLines = deletedComboLines.filter(
        (i) => i.product != e.target.value,
      );
      combo.total = parseFloat(combo.total) + parseFloat(productobj.unitPrice);
      combo.comboLines = [...comboLines];
      this.setState({ combo, comboDetailOptionForUpdate, deletedComboLines });
    } else {
      let combo = { ...this.state.combo };
      let comboLines = [...this.state.combo.comboLines];
      let deletedComboLines = [...this.state.deletedComboLines];
      let deletedItem = {
        ...comboLines.filter((i) => i.product == e.target.value)[0],
      };
      deletedItem.action = "D";
      deletedComboLines.push(deletedItem);
      comboLines = [...comboLines.filter((i) => i.product != e.target.value)];
      combo.comboLines = [...comboLines];
      combo.total = combo.total - product.salesPriceTax;
      // no of selected product
      let comboDetailOptionForUpdate = this.state.comboDetailOptionForUpdate;
      let index = this.state.comboDetailOptionForUpdate.findIndex(
        (i) => i.id == parentProduct.id,
      );
      comboDetailOptionForUpdate[index].noOfSelected = selectedItems;
      if (comboDetailOptionForUpdate[index].noOfSelected) {
        if (
          comboDetailOptionForUpdate[index].noOfSelected >=
          parentProduct.maxProduct
        ) {
          comboDetailOptionForUpdate[index].noOfSelected =
            comboDetailOptionForUpdate[index].noOfSelected - 1;
        } else {
          comboDetailOptionForUpdate[index].noOfSelected =
            comboDetailOptionForUpdate[index].noOfSelected - 1;
        }
      } else {
        comboDetailOptionForUpdate[index].noOfSelected = 0;
      }

      this.setState({ combo, comboDetailOptionForUpdate, deletedComboLines });
    }
  };
  handleComboProductsUpdateOnOk = () => {
    let comboDetailOptionForUpdate = this.state.comboDetailOptionForUpdate;
    for (let i = 0; i < comboDetailOptionForUpdate.length; i++) {
      if (comboDetailOptionForUpdate[i].noOfSelected) {
        if (
          comboDetailOptionForUpdate[i].maxProduct >=
            comboDetailOptionForUpdate[i].noOfSelected &&
          comboDetailOptionForUpdate[i].noOfSelected >=
            comboDetailOptionForUpdate[i].minProduct
        ) {
        } else {
          message.error(this.props.lang.MESSAGES.PRODUCT_SELECTED_QTY_ERROR);
          return false;
        }
      } else {
        let selectedItems = 0;
        for (
          let j = 0;
          j < comboDetailOptionForUpdate[i].products.length;
          j++
        ) {
          if (
            this.state.combo.comboLines.filter(
              (it) =>
                it.product ==
                comboDetailOptionForUpdate[i].products[j].productId,
            ).length > 0
          ) {
            selectedItems = selectedItems + 1;
          }
        }
        if (
          comboDetailOptionForUpdate[i].maxProduct >= selectedItems &&
          selectedItems >= comboDetailOptionForUpdate[i].minProduct
        ) {
        } else {
          message.error(this.props.lang.MESSAGES.PRODUCT_SELECTED_QTY_ERROR);
          return false;
        }
      }
    }

    let comboLinesToSendToServerForUpdate = [];
    for (let i = 0; i < this.state.combo.comboLines.length; i++) {
      if (
        this.state.deletedComboLines.filter(
          (a) => a.id == this.state.combo.comboLines[i].id,
        ) < 1
      ) {
        if (
          this.state.combo.comboLines[i].action &&
          this.state.combo.comboLines[i].action == "N"
        ) {
          let itemToPush = {
            action: this.state.combo.comboLines[i].action,
            product: this.state.combo.comboLines[i].product,
            uom: this.state.combo.comboLines[i].uom,
            unitPrice: this.state.combo.comboLines[i].salesPriceTax,
            priceWithoutTax: this.state.combo.comboLines[i].salesPrice,
            tax: this.state.combo.comboLines[i].tax,
            collectPoints: this.state.combo.comboLines[i].collectPoints,
          };
          comboLinesToSendToServerForUpdate.push(itemToPush);
        } else {
          let itemToPush = {
            id: this.state.combo.comboLines[i].id,
            action: "E",
          };
          comboLinesToSendToServerForUpdate.push(itemToPush);
        }
      }
    }
    let testArray = [...this.state.deletedComboLines];
    for (let a = 0; a < testArray.length; a++) {
      let itemToPush = {
        id: testArray[a].id,
        action: "D",
      };
      comboLinesToSendToServerForUpdate.push(itemToPush);
    }

    let data = {
      lang: localStorage.getItem("lang"),
      id: this.state.updatingComboId,
      qty: this.state.combo.qty,
      comboLines: [...comboLinesToSendToServerForUpdate],
    };

    axios({
      url: API_URL + "updateSaleOrderComboLine",
      method: "POST",
      data,
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    }).then((res) => {
      if (res.data.success) {
        message.success(res.data.message);
        this.setState({ comboProductsModalUpdate: false }, () => {
          this.props.getsaleOrderLine();
        });
      } else {
        message.error(res.data.message);
      }
    });
  };
  cancelOrderItem = (item, isIngrUpdate) => {
    axios({
      url: API_URL + "cancelSaleOrderLine",
      method: "POST",
      data: {
        id: item[0].id,
        lang: localStorage.getItem("lang"),
        isIngrUpdate: isIngrUpdate,
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    }).then((res) => {
      if (res.data.success) {
        message.success(res.data.message);
        this.setState({ visible2: false, popoverVisible: false }, () => {
          this.props.getsaleOrderLine();
          if (item[0].status == "K") {
            this.props.senPrintOnCancelOrder(item[0].id);
          }
        });
      } else {
        message.error(res.data.message);
      }
    });
  };
  showModalOnAddItem = (item, isGroupProduct) => {
    let addedAdditionalItemsParent = { ...item };
    this.setState(
      {
        addedAdditionalItemsParent,
        isGroupProduct: isGroupProduct,
        cancel: true,
        selectedOrderLine: item.id,
        selectedOrderLineProduct: item.product,
        selectedOrderLineUom: item.uom,
        selectedqty: item.qty,
        refqty: item.qty,
        reFundqty: item.refundQty,
        selectedOrderLineUnitPrice: item.unitPrice,
        selectedOrderLineUnitPriceWithoutTax: item.priceWithoutTax,
      },
      () => this.showModal("poslineAdded"),
    );
  };

  addAdditionalItemsToArray = (e, item, qty, orderItem, checkRemo) => {
    let addedAdditionalItems = [...this.state.addedAdditionalItems];
    let data = {
      lang: localStorage.getItem("lang"),
      client: localStorage.getItem("clientId"),
      // order: JSON.parse(localStorage.getItem('posStorage')).orderId,
      order: this.props.posStorage.orderId,
      product: item.id,
      qty: 1,
      uom: item.uomId,
      unitPrice: item.price,
      priceWithoutTax: item.priceWithoutTax,
      parentProduct: this.state.selectedOrderLine,

      checkRemo,
    };
    if (this.state.isGroupProduct) {
      data.isGroupItem = true;
      data.isGroupProduct = false;
      data.isAddProduct = false;
    } else {
      data.isGroupItem = false;
      data.isGroupProduct = false;
      data.isAddProduct = true;
    }
    if (
      addedAdditionalItems.find(
        (i) => i.product == data.product && i.uom == data.uom,
      ) == undefined
    ) {
      addedAdditionalItems.push(data);
    } else {
      addedAdditionalItems = addedAdditionalItems.filter(
        (i) => i.product != data.product,
      );
    }
    if (this.state.isGroupProduct) {
      let totalqty = 0;
      let min =
        this.state.addedAdditionalItemsParent.min * this.state.selectedqty;
      let max =
        this.state.addedAdditionalItemsParent.max * this.state.selectedqty;
      addedAdditionalItems.forEach((product) => {
        totalqty = product.qty + totalqty;
      });
      if (totalqty >= min && totalqty <= max) {
        this.setState({ visibleOkButton: false });
      } else {
        this.setState({ visibleOkButton: true });
      }
    }
    this.setState({ addedAdditionalItems });
  };
  addAdditionalItemsToArrayIncreament = (
    e,
    item,
    qty,
    orderItem,
    checkRemo,
  ) => {
    let addedAdditionalItems = [...this.state.addedAdditionalItems];
    if (
      addedAdditionalItems.find(
        (i) => i.product == item.id && i.uom == item.uomId,
      ) != undefined
    ) {
      let index = addedAdditionalItems.findIndex(
        (i) => i.product == item.id && i.uom == item.uomId,
      );
      addedAdditionalItems[index].qty = qty;
    }
    if (this.state.isGroupProduct) {
      let totalqty = 0;
      let min =
        this.state.addedAdditionalItemsParent.min * this.state.selectedqty;
      let max =
        this.state.addedAdditionalItemsParent.max * this.state.selectedqty;
      addedAdditionalItems.forEach((product) => {
        totalqty = product.qty + totalqty;
      });
      if (totalqty >= min && totalqty <= max) {
        this.setState({ visibleOkButton: false });
      } else {
        this.setState({ visibleOkButton: true });
      }
    }
    this.setState({ addedAdditionalItems });
  };
  addRemoAddProduct = (e, item, qty, orderItem, checkRemo) => {
    let checkqty = 0;
    if (checkRemo.isGroupProduct) {
      this.state.additionalProduct.forEach((items) => {
        checkqty =
          checkRemo.items.length > 0 &&
          checkRemo.items.filter((i) => i.product == items.id).length > 0 &&
          checkRemo.items.filter((i) => i.product == items.id)[0].qty +
            checkqty;
      });
      if (checkRemo.add) {
        if (checkRemo.max < checkqty + 1) {
          return false;
        }
      } else {
        if (checkRemo.min > checkqty - 1) {
          return false;
        }
      }
    }
    if (
      this.props.totalOrder.status == "DR" ||
      this.props.totalOrder.status == "K"
    ) {
      // console.log(this.props.totalOrder.status)
      let headers = {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      };
      if (e.target.checked) {
        let data = {
          lang: localStorage.getItem("lang"),
          client: localStorage.getItem("clientId"),
          // order: JSON.parse(localStorage.getItem('posStorage')).orderId,
          order: this.props.posStorage.orderId,
          product: item.id,
          qty: 1,
          uom: item.uomId,
          priceWithoutTax: item.priceWithoutTax,
          unitPrice: item.price,
          parentProduct: this.state.selectedOrderLine,
        };
        if (this.state.isGroupProduct) {
          data.isGroupItem = true;
        } else {
          data.isAddProduct = true;
        }

        let authOptions = {
          url: API_URL + "createSaleOrderLine",
          method: "POST",
          data,
          headers,
        };
        axios(authOptions)
          .then((res) => {
            if (res.data.success) {
              this.setState({ notesForKitchen: null });

              // message.success(res.data.message)
              this.props.getsaleOrderLine();
            } else {
              message.error(res.data.message);
            }
            // console.log('whyen sale order line created',authOptions)
            // console.log('whyen sale order line created',res)
          })
          .catch((err) => {
            // console.log(err)
          });
      } else {
        if (qty) {
          let newdata = {
            lang: localStorage.getItem("lang"),
            id: orderItem.length > 0 && orderItem[0].id,
            qty: parseInt(qty),
            product: orderItem[0].product,
            uom: orderItem[0].uom,
            unitPrice: orderItem[0].unitPrice,
            priceWithoutTax: orderItem[0].priceWithoutTax,
            isAddProduct: true,
            parentProduct: this.state.selectedOrderLine,
            cashier: JSON.parse(localStorage.getItem("userData")).userId,
          };
          if (this.state.isGroupProduct) {
            newdata.isGroupItem = true;
          } else {
            newdata.isAddProduct = true;
          }

          let authOptions = {
            url: API_URL + "updateSaleOrderLine",
            method: "POST",
            data: newdata,
            headers,
          };
          axios(authOptions)
            .then((res) => {
              if (res.data.success) {
                // message.success(res.data.message)
                this.props.getsaleOrderLine();
              } else {
                message.error(res.data.message);
              }
            })
            .catch((err) => {});
        } else {
          // console.log(orderItem)
          let data = {
            lang: localStorage.getItem("lang"),
            id: orderItem.length > 0 && orderItem[0].id,
          };
          let authOptions = {
            url: API_URL + "deleteSaleOrderLine",
            method: "POST",
            data,
            headers,
          };
          axios(authOptions).then((res) => {
            // console.log('when sale order line updated',authOptions)
            // console.log('when sale order line updated',res)
            if (res.data.success) {
              this.props.getsaleOrderLine();
            }
          });
        }
      }
    }
  };
  deleteSaleOrderLineCombo = () => {
    axios({
      method: "POST",
      url: API_URL + "deleteSaleOrderLine",
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
      data: {
        id: this.state.updatingComboId,
        lang: localStorage.getItem("lang"),
      },
    }).then((res) => {
      if (res.data.success) {
        message.success(res.data.message);
        this.setState(
          { updatingComboId: "", comboProductsModalUpdate: false },
          () => {
            this.props.getsaleOrderLine();
          },
        );
      } else {
        message.error(res.data.message);
      }
    });
  };

  focus() {
    this.textInput.focus();
  }

  confirmPayment = (paymentMethodName) => {
    const remainingAmount = this.getRemainingAmount();
    const totalOrder = this.state.totalOrder;
    const orderNo = totalOrder
      ? totalOrder.tokenNo || totalOrder.documentNo || "-"
      : "-";
    const paymethods = this.props.paymethods || [];

    if (remainingAmount <= 0) {
      Swal.fire({
        title: this.props.lang.ERROR || "Error",
        text: this.props.lang.NO_AMOUNT_TO_PAY || "No amount to pay",
        icon: "error",
        confirmButtonText: this.props.lang.OK || "OK",
      });
      return;
    }

    const payMethod = paymethods.find(
      (item) => item.name.toLowerCase() === paymentMethodName.toLowerCase(),
    );

    if (!payMethod) {
      Swal.fire({
        title: this.props.lang.ERROR || "Error",
        text: `${paymentMethodName} ${this.props.lang
          .PAYMENT_METHOD_NOT_FOUND || "not found"}`,
        icon: "error",
        confirmButtonText: this.props.lang.OK || "OK",
      });
      return;
    }

    const payMethodId = payMethod.id;

    // عرض SweetAlert للتأكيد (نسخة مبسطة)
    Swal.fire({
      title: this.props.lang.CONFIRM_PAYMENT || "Confirm Payment",
      text: `${paymentMethodName} - ${remainingAmount} (${orderNo})`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: this.props.lang.CONFIRM || "Confirm",
      cancelButtonText: this.props.lang.CANCEL || "Cancel",
      confirmButtonColor: "#52c41a",
      cancelButtonColor: "#d33",
    }).then(async (result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: this.props.lang.PROCESSING || "Processing...",
          text: this.props.lang.PLEASE_WAIT || "Please wait",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        try {
          await this.changePayMethod(payMethodId);
          await this.processPayment(
            paymentMethodName,
            remainingAmount,
            payMethodId,
          );

          if (this.props.paymentok) {
            this.props.paymentok(remainingAmount, remainingAmount);
          }
          if (this.props.getsaleOrderLine) {
            this.props.getsaleOrderLine();
          }
        } catch (error) {
          Swal.fire({
            title: this.props.lang.PAYMENT_FAILED || "Payment Failed!",
            text:
              error.message || this.props.lang.TRY_AGAIN || "Please try again",
            icon: "error",
            confirmButtonText: this.props.lang.OK || "OK",
          });
        }
      }
    });
  };

  // تغيير طريقة الدفع
  changePayMethod = (payMethodId) => {
    const { totalOrder } = this.state;

    if (!totalOrder || !totalOrder.id) {
      return Promise.reject(new Error("Order not found"));
    }

    return axios({
      url: API_URL + "updateSaleOrder",
      method: "POST",
      data: {
        lang: localStorage.getItem("lang"),
        id: totalOrder.id,
        customer: totalOrder.customer,
        payMethod: payMethodId,
        flrTable: totalOrder.flrTable,
        orderType: totalOrder.orderType,
        cashier: JSON.parse(localStorage.getItem("userData")).userId,
        noOfGuest: totalOrder.noOfGuest,
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    });
  };

  processPayment = async (paymentMethodName, amount, payMethodId) => {
    const { totalOrder, actualAmt, discountAmt, isDiscount } = this.state;

    const data = {
      saleOrderId: totalOrder.id,
      lang: localStorage.getItem("lang"),
      cashier: JSON.parse(localStorage.getItem("userData")).userId,
      totalNet: totalOrder.totalNet,
      coupon: null,
      discountAmt: discountAmt || 0,
      actualAmt: actualAmt || totalOrder.totalNet,
      isDiscount: isDiscount || false,
      couponNo: null,
      payMethod: payMethodId,
      payCash: 0,
      paymentAmt: amount,
      isColPointUsed: false,
      collectPoints: 0,
    };

    const response = await axios({
      url: API_URL + "paySaleOrder",
      method: "POST",
      data: data,
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    });

    if (!response.data.success) {
      throw new Error(response.data.message);
    }

    return response.data;
  };

  getRemainingAmount = () => {
    const { totalOrder, extraCharge } = this.state;
    const totalNet = totalOrder ? totalOrder.totalNet || 0 : 0;
    const paidAmt = totalOrder ? totalOrder.paidAmt || 0 : 0;
    const remaining = (
      (parseFloat(extraCharge) || 0) +
      parseFloat(totalNet) -
      parseFloat(paidAmt)
    ).toFixed(2);
    return remaining;
  };
  render() {
    const { totalOrder } = this.props;
    let ext = ".jpg";
    let imageContent = "image/jpeg";

    return (
      <React.Fragment>
        {/* customcode start here */}

        <div
          style={{ direction: this.props.lang.INJAZ_AUTH_DIRECTION }}
          className="custompayslipsec"
        >
          {totalOrder &&
            totalOrder.status !== "C" &&
            this.props.posStorage &&
            this.props.posStorage.orderId && (
              <div className="time">
                <span className="slipinfo">
                  #{totalOrder.tokenNo && totalOrder.tokenNo}
                </span>
                <span className="slipinfo">
                  {totalOrder.initTime && (
                    <Timer
                      time={totalOrder.initTime}
                      classnameProps="containerTimer1"
                      localStorage={"timer" + totalOrder.id}
                      interval={1000}
                      ref="resetTimer"
                    />
                  )}
                </span>
                <span className="slipinfo">
                  {totalOrder.orderType && totalOrder.orderType == "DI"
                    ? this.props.lang.DINEIN
                    : totalOrder.orderType == "HD"
                    ? this.props.lang.HOMEDELIVERY
                    : totalOrder.orderType == "TA"
                    ? this.props.lang.TAKEAWAY
                    : ""}
                </span>
              </div>
            )}

          <div className="cartdiv cartdiv2">
            {this.props.posProductsLists &&
              this.props.posProductsLists.length > 0 &&
              this.props.posProductsLists.some(
                (item) =>
                  item.isComboChild == false &&
                  item.isAddProduct == false &&
                  item.isGroupItem == false &&
                  item.status != "C",
              ) && (
                <table className="pos-products-table">
                  <thead className="table-header">
                    <tr>
                      <th className="header-cell header-product">
                        {this.props.lang.PRODUCT || "Product"}
                      </th>
                      <th className="header-cell header-qty">
                        {this.props.lang.QTY || "Qty"}
                      </th>
                      <th className="header-cell header-unit-price">
                        {this.props.lang.UNIT_PRICE || "Unit Price"}
                      </th>
                      <th className="header-cell header-total">
                        {this.props.lang.TOTAL || "Total"}
                      </th>
                      <th className="header-cell header-status">
                        {this.props.lang.STATUS || "Status"}
                      </th>
                      <th className="header-cell header-status">
                        {this.props.lang.ACTION || "Action"}
                      </th>
                    </tr>
                  </thead>
                  {this.props.posProductsLists.map(
                    (item) =>
                      item.isComboChild == false &&
                      item.isAddProduct == false &&
                      item.isGroupItem == false &&
                      item.status != "C" && (
                        <tbody
                          key={item.id}
                          className="product-group"
                          style={{
                            backgroundColor:
                              this.state.selectedOrderLine === item.id
                                ? ""
                                : "",
                          }}
                        >
                          {/* === Main Product Row === */}
                          <tr className="product-row">
                            <td
                              onClick={() => {
                                if (
                                  this.props.totalOrder.status == "DR" ||
                                  this.props.totalOrder.status == "K"
                                ) {
                                  if (item.status == "DR") {
                                    if (item.combo) {
                                      this.comboProductUpdateOpenHandler(item);
                                    } else {
                                      this.setState(
                                        {
                                          notesForKitchen: item.notes,
                                          isGroupProduct: item.isGroupProduct,
                                          selectedOrderLine: item.id,
                                          notesForKitchenParentLine: item.notes,
                                          selectedOrderLineProduct:
                                            item.product,
                                          selectedOrderLineUom: item.uom,
                                          selectedqty: item.qty,
                                          refqty: item.qty,
                                          reFundqty: item.refundQty,
                                          selectedOrderLineUnitPrice:
                                            item.unitPrice,
                                          selectedOrderLineUnitPriceWithoutTax:
                                            item.priceWithoutTax,
                                        },
                                        () => this.showModal2("poslineAdded"),
                                      );
                                    }
                                  } else {
                                    if (item.status == "K") {
                                      if (
                                        JSON.parse(
                                          localStorage.getItem("userData"),
                                        ).isManager
                                      ) {
                                        if (item.combo) {
                                          this.comboProductUpdateOpenHandler(
                                            item,
                                          );
                                        } else {
                                          this.setState(
                                            {
                                              notesForKitchen: item.notes,
                                              selectedOrderLine: item.id,
                                              notesForKitchenParentLine:
                                                item.notes,
                                              selectedOrderLineProduct:
                                                item.product,
                                              selectedOrderLineUom: item.uom,
                                              selectedqty: item.qty,
                                              reFundqty: item.refundQty,
                                              refqty: item.qty,
                                              selectedOrderLineUnitPrice:
                                                item.unitPrice,
                                              selectedOrderLineUnitPriceWithoutTax:
                                                item.priceWithoutTax,
                                            },
                                            () =>
                                              this.showModal2("poslineAdded"),
                                          );
                                        }
                                      } else {
                                        this.props.totalOrder.status != "RI" &&
                                          message.error(
                                            this.props.lang.MESSAGES
                                              .SEND_TO_KITCHEN_ERROR,
                                          );
                                      }
                                    }
                                  }
                                } else {
                                  if (
                                    this.props.totalOrder.status == "RI" &&
                                    item.combo
                                  ) {
                                    this.setState({ refundObject: item }, () =>
                                      this.setState({ refunModal: true }),
                                    );
                                  } else {
                                    if (this.props.totalOrder.status != "RI") {
                                      message.error(
                                        this.props.lang.MESSAGES
                                          .ORDER_PAY_ERROR,
                                      );
                                    }
                                  }
                                }
                              }}
                              className="cell-product"
                            >
                              {item.qty > 0 && (
                                <div
                                  className="product-main"
                                  onClick={(i) => {
                                    this.props.totalOrder.status == "RI" &&
                                      (item.qty > 0
                                        ? this.setState(
                                            { refundObject: item },
                                            () =>
                                              this.setState({
                                                refunModal: true,
                                              }),
                                          )
                                        : message.error(
                                            this.props.lang
                                              .MESSAGESREFUND_ERROR,
                                          ));
                                  }}
                                >
                                  <div className="product-image">
                                    <MyImg
                                      src={`${API_URL}getImage?imageId=${item.productImage}&lang=EN`}
                                    />
                                  </div>

                                  <span className="product-name">
                                    {item.isCombo
                                      ? this.state.combosList.length > 0 &&
                                        this.state.combosList.filter(
                                          (it) => it.id == item.combo,
                                        ).length > 0 &&
                                        this.state.combosList.filter(
                                          (it) => it.id == item.combo,
                                        )[0].name
                                      : localStorage.getItem("lang") == "EN"
                                      ? this.props.productList.length > 0 &&
                                        this.props.productList.filter(
                                          (i) => i.id === item.product,
                                        ).length > 0 &&
                                        this.props.productList.filter(
                                          (i) => i.id === item.product,
                                        )[0].name
                                      : this.props.productList.length > 0 &&
                                        this.props.productList.filter(
                                          (i) => i.id === item.product,
                                        ).length > 0 &&
                                        this.props.productList.filter(
                                          (i) => i.id === item.product,
                                        )[0].nameAr}
                                  </span>
                                </div>
                              )}
                            </td>

                            <td className="cell-qty">{item.qty} X</td>

                            <td className="cell-unit-price">
                              {JSON.parse(
                                localStorage.getItem("isInclusiveTax"),
                              )
                                ? item.unitPrice
                                : item.priceWithoutTax}
                            </td>

                            <td className="cell-total">
                              {JSON.parse(
                                localStorage.getItem("isInclusiveTax"),
                              )
                                ? item.totalNetLine
                                : item.netLineWithoutTax}
                            </td>

                            <td className="cell-status">
                              <span
                                className={`status-badge status-${item.status.toLowerCase()}`}
                              >
                                {item.status == "C"
                                  ? this.props.lang.COMPLETED || "Completed"
                                  : item.status === "K"
                                  ? this.props.lang.KITCHEN || "Kitchen"
                                  : item.status === "DR"
                                  ? this.props.lang.DRAFT || "Draft"
                                  : item.status}
                              </span>
                            </td>

                            <td className="cell-delete">
                              <button
                                type="button"
                                onClick={() => {
                                  if (
                                    this.props.posProductsLists.filter(
                                      (i) => i.id === item.id,
                                    )[0].status == "K"
                                  ) {
                                    this.setState({ popoverVisible: true });
                                  } else {
                                    this.cancelOrderItem(
                                      this.props.posProductsLists.filter(
                                        (i) => i.id === item.id,
                                      ),
                                      true,
                                    );
                                  }
                                }}
                              >
                                {this.props.lang.DELETE || "Delete"}
                              </button>
                            </td>
                          </tr>

                          {/* === Child Products (Combo / Add-on / Group) === */}
                          {this.props.posProductsLists &&
                            this.props.posProductsLists.length > 0 &&
                            this.props.posProductsLists.map(
                              (itemline, index) =>
                                (itemline.isComboChild == true ||
                                  itemline.isAddProduct == true ||
                                  itemline.isGroupItem == true) &&
                                itemline.qty > 0 &&
                                itemline.parentProduct == item.id && (
                                  <tr
                                    key={index}
                                    className="sub-product-row"
                                    onClick={(item) => {
                                      this.props.totalOrder.status == "RI" &&
                                        (itemline.qty > 0
                                          ? item.isComboChild == false
                                            ? this.setState(
                                                { refundObject: item },
                                                () =>
                                                  this.setState({
                                                    refunModal: true,
                                                  }),
                                              )
                                            : this.setState(
                                                { refundObject: itemline },
                                                () =>
                                                  this.setState({
                                                    refunModal: true,
                                                  }),
                                              )
                                          : message.error(
                                              this.props.lang
                                                .MESSAGESREFUND_ERROR,
                                            ));
                                    }}
                                  >
                                    <td className="cell-product">
                                      <span className="sub-product-name">
                                        {localStorage.getItem("lang") == "EN"
                                          ? this.state.productsListByClient
                                              .length > 0 &&
                                            this.state.productsListByClient.filter(
                                              (i) => i.id === itemline.product,
                                            ).length > 0 &&
                                            this.state.productsListByClient.filter(
                                              (i) => i.id === itemline.product,
                                            )[0].name
                                          : this.state.productsListByClient
                                              .length > 0 &&
                                            this.state.productsListByClient.filter(
                                              (i) => i.id === itemline.product,
                                            ).length > 0 &&
                                            this.state.productsListByClient.filter(
                                              (i) => i.id === itemline.product,
                                            )[0].nameAr}
                                      </span>
                                    </td>

                                    <td className="cell-qty">
                                      {itemline.qty} X
                                    </td>

                                    <td className="cell-unit-price">
                                      {this.props.lang.SAR || "SAR"}{" "}
                                      {JSON.parse(
                                        localStorage.getItem("isInclusiveTax"),
                                      )
                                        ? itemline.unitPrice
                                        : itemline.priceWithoutTax}{" "}
                                    </td>

                                    <td className="cell-total">
                                      {this.props.lang.SAR || "SAR"}{" "}
                                      {JSON.parse(
                                        localStorage.getItem("isInclusiveTax"),
                                      )
                                        ? itemline.totalNetLine
                                        : itemline.netLineWithoutTax}
                                    </td>

                                    <td className="cell-status">—</td>
                                  </tr>
                                ),
                            )}
                        </tbody>
                      ),
                  )}
                </table>
              )}
          </div>
          {!this.isEmpty(this.state.totalOrder) &&
          this.props.posProductsLists &&
          this.props.posProductsLists.length > 0 ? (
            this.props.totalOrder.status == "DR" ||
            this.props.totalOrder.status == "K" ||
            this.props.totalOrder.status == "PP" ? (
              <>
                <div
                  style={{ direction: this.props.lang.INJAZ_AUTH_DIRECTION }}
                  className="prodivcontAndPaymentShortcutButtons"
                >
                  <div className="payment-summary-table">
                    {/* رسوم التبغ */}
                    {this.state.saleOrderTobaccoByOrder && (
                      <div className="summary-row tobacco-row">
                        <span className="summary-label">
                          {this.props.lang.TOBACCO_FEE || "Tobacco Fee"}:
                        </span>
                        <span className="summary-value">
                          {this.state.saleOrderTobaccoByOrder.totalNetLine}
                        </span>
                      </div>
                    )}

                    {/* الإجمالي بدون ضريبة */}
                    {this.state.totalOrder.totalWithoutTax && (
                      <div className="summary-row">
                        <span className="summary-label">
                          {this.props.lang.SUB_TOTAL || "Sub Total"}:
                        </span>
                        <span className="summary-value">
                          {this.state.totalOrder.totalWithoutTax.toFixed(2)}
                        </span>
                      </div>
                    )}

                    {/* قيمة الضريبة */}
                    <div className="summary-row tax-row">
                      <span className="summary-label">
                        {this.props.lang.TAX_AMOUNT || "Tax Amount"}:
                      </span>
                      <span className="summary-value">
                        {(
                          this.state.totalOrder.totalNet -
                          this.state.totalOrder.totalWithoutTax
                        ).toFixed(2)}
                      </span>
                    </div>

                    {/* الإجمالي النهائي */}
                    <div className="summary-row total-row">
                      <span className="summary-label">
                        {this.props.lang.TOTAL_AMOUNT || "Total Amount"}:
                      </span>
                      <span className="summary-value total-amount">
                        {this.state.totalOrder.totalNet.toFixed(2)}
                      </span>
                    </div>
                  </div>

                  <div className="paymentShortcutButtons">
                    <div
                      className="paymentShortcutButton"
                      onClick={() => this.confirmPayment("CASH")}
                    >
                      <i>
                        <RiCashFill />
                      </i>
                      <p>{this.props.lang.CASH || "Cash"}</p>
                    </div>
                    <div
                      className="paymentShortcutButton"
                      onClick={() => this.confirmPayment("CARD")}
                    >
                      <i>
                        <FaRegAddressCard />
                      </i>
                      <p>{this.props.lang.CARD || "Card"}</p>
                    </div>
                    <div
                      className="paymentShortcutButton"
                      onClick={() => this.props.paymentScreen()}
                    >
                      <i>
                        <BsThreeDots />
                      </i>
                      <p>{this.props.lang.OTHER || "Other"}</p>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                {this.state.saleOrderTobaccoByOrder && (
                  <div id="tobacco_div">
                    <p>{this.props.lang.TOBACCOFEE}</p>
                    <p>
                      {" " + this.state.saleOrderTobaccoByOrder.totalNetLine}
                    </p>
                  </div>
                )}
                <span>
                  <p>
                    <span style={{ fontWeight: "bold", float: "none" }}>
                      {this.props.lang.TOTAL_AMOUNT}:
                    </span>{" "}
                    {this.state.totalOrder.totalWithoutTax}
                    <span style={{ fontWeight: "bold", float: "none" }}>
                      {" "}
                      {this.props.lang.REFUND_AMOUNT}:
                    </span>{" "}
                    {this.state.totalOrder.refundAmt}
                  </p>
                </span>
              </>
            )
          ) : (
            <div
              className="priceDiv"
              style={{
                cursor: "pointer",
                height: "60px !important",
              }}
              onClick={() => this.props.paymentScreen()}
            >
              <p
                style={{ fontWeight: "700", fontSize: "24", margin: "0 auto" }}
              >
                {this.props.lang.PAYMENT}
              </p>
            </div>
          )}
        </div>
        {/* <Input
          ref={(input) => {
            this.textInput = input;
          }}
          id="barcodeinput"
          onKeyPress={(event) => {
            if (event.key === "Enter") {
              let value = this.textInput.input.value;
              this.textInput.input.value = "";
              document.getElementById("barcodeinput").value = "";
              axios({
                url: API_URL + "productByBarcode",
                method: "GET",
                params: {
                  lang: localStorage.getItem("lang"),
                  clientId: localStorage.getItem("clientId"),
                  barcode: value,
                },
                headers: {
                  Authorization:
                    localStorage.getItem("tokenType") +
                    " " +
                    localStorage.getItem("accessToken"),
                  "Content-Type": "application/json",
                },
              })
                .then((res) => {
                  if (res.data.length < 1) {
                    message.error("No Product found!");
                    return;
                  }
                  this.setState({ barcodeinput: "" });
                  if (
                    res.data.length == 1 &&
                    res.data[0].isGroupProduct == false
                  ) {
                    let headers = {
                      Authorization:
                        localStorage.getItem("tokenType") +
                        " " +
                        localStorage.getItem("accessToken"),
                      "Content-Type": "application/json",
                    };
                    let authOptions = {
                      url: API_URL + "createSaleOrderLine",
                      method: "POST",
                      data: {
                        lang: localStorage.getItem("lang"),
                        client: localStorage.getItem("clientId"),
                        order: this.props.posStorage.orderId,
                        product: res.data[0].id,
                        isScaleProduct: res.data[0].isScaleProduct,
                        qty: 1,
                        uom: res.data[0].uomId,
                        isGroupProduct: false,
                        priceWithoutTax: res.data[0].priceWithoutTax,
                        unitPrice: res.data[0].price,
                        isOffer: res.data[0].isOffer,
                        prodOffer: null,
                        offerType: res.data[0].offerType,
                        isAddProduct: false,
                        actualPrice: res.data[0].price,
                        isDiscount: false,
                        items: [],
                      },
                      headers,
                    };
                    axios(authOptions).then((res) => {
                      if (res.data.success) {
                        this.setState({ notesForKitchen: null });

                        this.props.getsaleOrderLine();
                      } else {
                        message.error(res.data.message);
                      }
                    });
                    return;
                  }
                  if (res.data.length == 1 && res.data[0].isGroupProduct) {
                    this.props.addProduct(res.data[0].id);

                    return;
                  }
                  if (res.data.length > 1) {
                  }
                })
                .catch((e) => {
                  message.error("No Product found!");
                });
              this.textInput.input.value = "";
              document.getElementById("barcodeinput").value = "";
            }
            // setTimeout(() => {
            // document.getElementById('inp_text').value = '';
            // }, 800);
          }}
          onChange={(e) => {
            this.setState({ barcodeinput: e.target.value });
          }}
          value={this.state.barcodeinput}
          style={{ fontSize: "16px" }}
          type="text"
          placeholder="Type Barcode here and press enter"
        /> */}

        {/* my custom code end here */}

        {/* {
          totalOrder.status != "C" && this.props.posStorage && this.props.posStorage.orderId &&
          <div className="order_label_top" style={{ textAlign: "center", marginTop: 10 }}>
            {"#"}{totalOrder.tokenNo && totalOrder.tokenNo}{" "}
            <span style={{ fontWeight: "bolder", textAlign: "center" }}>
              {totalOrder.initTime && <Timer time={totalOrder.initTime} classnameProps="containerTimer1"
                localStorage={'timer' + totalOrder.id} interval={1000} ref='resetTimer' />}
            </span>{" "}
            <span style={{ fontWeight: "bolder", textAlign: "center" }}>
              {totalOrder.orderType && totalOrder.orderType == "DI" ? "Dine in" : totalOrder.orderType == "HD" ? "Home Delivery" : totalOrder.orderType == "TA" ? "Take Away" : ""}
            </span>{" "}
          </div>
        } */}

        <Card
          className="orderLine"
          headStyle={{ minHeight: "80px", maxHeight: "120px" }}
          style={{
            display: "none",
            direction: this.props.lang.INJAZ_AUTH_DIRECTION,
          }}
        >
          <div id="style-13">
            {/* {
              console.log(this.props.posProductsLists, 'props posproduct lists')
            } */}

            {this.props.posProductsLists &&
              this.props.posProductsLists.length > 0 &&
              this.props.posProductsLists.map(
                (item) =>
                  item.isComboChild == false &&
                  item.isAddProduct == false &&
                  item.isGroupItem == false && (
                    <div
                      // style={{ borderColor: "red !important" }}
                      className="outermainboxclass"
                      onClick={() => {
                        if (
                          this.props.totalOrder.status == "DR" ||
                          this.props.totalOrder.status == "K"
                        ) {
                          if (item.status == "DR") {
                            if (item.combo) {
                              this.comboProductUpdateOpenHandler(item);
                            } else {
                              this.setState(
                                {
                                  notesForKitchen: item.notes,
                                  isGroupProduct: item.isGroupProduct,
                                  selectedOrderLine: item.id,
                                  notesForKitchenParentLine: item.notes,
                                  selectedOrderLineProduct: item.product,
                                  selectedOrderLineUom: item.uom,
                                  selectedqty: item.qty,
                                  refqty: item.qty,
                                  reFundqty: item.refundQty,
                                  selectedOrderLineUnitPrice: item.unitPrice,
                                  selectedOrderLineUnitPriceWithoutTax:
                                    item.priceWithoutTax,
                                },
                                () => this.showModal2("poslineAdded"),
                              );
                            }
                          } else {
                            if (item.status == "K") {
                              if (
                                JSON.parse(localStorage.getItem("userData"))
                                  .isManager
                              ) {
                                if (item.combo) {
                                  this.comboProductUpdateOpenHandler(item);
                                } else {
                                  this.setState(
                                    {
                                      notesForKitchen: item.notes,
                                      selectedOrderLine: item.id,
                                      notesForKitchenParentLine: item.notes,
                                      selectedOrderLineProduct: item.product,
                                      selectedOrderLineUom: item.uom,
                                      selectedqty: item.qty,
                                      reFundqty: item.refundQty,
                                      refqty: item.qty,
                                      selectedOrderLineUnitPrice:
                                        item.unitPrice,
                                      selectedOrderLineUnitPriceWithoutTax:
                                        item.priceWithoutTax,
                                    },
                                    () => this.showModal2("poslineAdded"),
                                  );
                                }
                              } else {
                                this.props.totalOrder.status != "RI" &&
                                  message.error(
                                    this.props.lang.MESSAGES
                                      .SEND_TO_KITCHEN_ERROR,
                                  );
                              }
                            }
                          }
                        } else {
                          if (
                            this.props.totalOrder.status == "RI" &&
                            item.combo
                          ) {
                            this.setState({ refundObject: item }, () =>
                              this.setState({ refunModal: true }),
                            );
                          } else {
                            if (this.props.totalOrder.status != "RI") {
                              message.error(
                                this.props.lang.MESSAGES.ORDER_PAY_ERROR,
                              );
                            }
                          }
                        }
                      }}
                      key={item.id}
                      style={{
                        backgroundColor:
                          this.state.selectedOrderLine === item.id ? "" : "",
                        width: "100%",
                        paddingRight: "10px",
                        paddingLeft: "10px",
                      }}
                    >
                      {item.qty > 0 && (
                        <div
                          className="Checkthis"
                          onClick={(i) => {
                            this.props.totalOrder.status == "RI" &&
                              (item.qty > 0
                                ? this.setState({ refundObject: item }, () =>
                                    this.setState({ refunModal: true }),
                                  )
                                : message.error(
                                    this.props.lang.MESSAGESREFUND_ERROR,
                                  ));
                          }}
                          style={{
                            display: "flex",
                            flexDirection:
                              this.props.lang.INJAZ_AUTH_DIRECTION == "rtl"
                                ? "row-reverse"
                                : "row",
                            justifyContent: "space-between",
                          }}
                        >
                          <p style={{ fontWeight: 700 }}>
                            <Radio
                              className={
                                item.status == "C"
                                  ? "rbtn2"
                                  : item.status == "DR"
                                  ? "rbtn3"
                                  : "rbtn"
                              }
                              checked
                            />
                            {item.isCombo
                              ? this.state.combosList.length > 0 &&
                                this.state.combosList.filter(
                                  (it) => it.id == item.combo,
                                ).length > 0 &&
                                this.state.combosList.filter(
                                  (it) => it.id == item.combo,
                                )[0].name
                              : localStorage.getItem("lang") == "EN"
                              ? this.props.productList.length > 0 &&
                                this.props.productList.filter(
                                  (i) => i.id === item.product,
                                ).length > 0 &&
                                this.props.productList.filter(
                                  (i) => i.id === item.product,
                                )[0].name
                              : this.props.productList.length > 0 &&
                                this.props.productList.filter(
                                  (i) => i.id === item.product,
                                ).length > 0 &&
                                this.props.productList.filter(
                                  (i) => i.id === item.product,
                                )[0].nameAr}
                          </p>
                          <p>
                            {item.qty} X
                            {JSON.parse(localStorage.getItem("isInclusiveTax"))
                              ? item.unitPrice
                              : item.priceWithoutTax}
                          </p>
                          <p style={{ fontWeight: 700 }}>
                            {" "}
                            {JSON.parse(localStorage.getItem("isInclusiveTax"))
                              ? item.totalNetLine
                              : item.netLineWithoutTax}
                          </p>
                        </div>
                      )}

                      {this.props.posProductsLists &&
                        this.props.posProductsLists.length > 0 &&
                        this.props.posProductsLists.map(
                          (itemline, index) =>
                            (itemline.isComboChild == true ||
                              itemline.isAddProduct == true ||
                              itemline.isGroupItem == true) &&
                            itemline.qty > 0 &&
                            itemline.parentProduct == item.id && (
                              <div
                                key={index}
                                className="extraProduct"
                                onClick={(item) => {
                                  this.props.totalOrder.status == "RI" &&
                                    (itemline.qty > 0
                                      ? item.isComboChild == false
                                        ? this.setState(
                                            { refundObject: item },
                                            () =>
                                              this.setState({
                                                refunModal: true,
                                              }),
                                          )
                                        : this.setState(
                                            { refundObject: itemline },
                                            () =>
                                              this.setState({
                                                refunModal: true,
                                              }),
                                          )
                                      : message.error(
                                          this.props.lang.MESSAGESREFUND_ERROR,
                                        ));
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection:
                                      this.props.lang.INJAZ_AUTH_DIRECTION ==
                                      "rtl"
                                        ? "row-reverse"
                                        : "row",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <p style={{ fontWeight: 700 }}>
                                    {localStorage.getItem("lang") == "EN"
                                      ? this.state.productsListByClient.length >
                                          0 &&
                                        this.state.productsListByClient.filter(
                                          (i) => i.id === itemline.product,
                                        ).length > 0 &&
                                        this.state.productsListByClient.filter(
                                          (i) => i.id === itemline.product,
                                        )[0].name
                                      : this.state.productsListByClient.length >
                                          0 &&
                                        this.state.productsListByClient.filter(
                                          (i) => i.id === itemline.product,
                                        ).length > 0 &&
                                        this.state.productsListByClient.filter(
                                          (i) => i.id === itemline.product,
                                        )[0].nameAr}
                                  </p>
                                  <p>
                                    {itemline.qty} X SAR{" "}
                                    {JSON.parse(
                                      localStorage.getItem("isInclusiveTax"),
                                    )
                                      ? itemline.unitPrice
                                      : itemline.priceWithoutTax}{" "}
                                  </p>
                                  <p style={{ fontWeight: 700 }}>
                                    SAR{" "}
                                    {JSON.parse(
                                      localStorage.getItem("isInclusiveTax"),
                                    )
                                      ? itemline.totalNetLine
                                      : itemline.netLineWithoutTax}
                                  </p>
                                </div>
                              </div>
                            ),
                        )}
                    </div>
                  ),
              )}
            <div
              style={{ float: "left", clear: "both", border: "none" }}
              ref={(el) => {
                this.messagesEnd = el;
              }}
            ></div>
          </div>
          {!this.isEmpty(this.state.totalOrder) &&
          this.props.posProductsLists &&
          this.props.posProductsLists.length > 0 ? (
            this.props.totalOrder.status == "DR" ||
            this.props.totalOrder.status == "K" ||
            this.props.totalOrder.status == "PP" ? (
              <>
                {/* sales bottom taxsar*/}

                {this.state.saleOrderTobaccoByOrder && (
                  <div id="tobacco_div">
                    <p>Tobacco Fee</p>
                    <p>
                      {" " + this.state.saleOrderTobaccoByOrder.totalNetLine}
                    </p>
                  </div>
                )}
                <div
                  className="priceDiv priceDiv2"
                  style={{
                    height: "50px",
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "space-around",
                  }}
                  onClick={() => this.props.paymentScreen()}
                >
                  {/* <p style={{ fontWeight: '700', fontSize: '24' }}>SAR {JSON.parse(localStorage.getItem("isInclusiveTax")) ? this.props.totalOrder.totalNet : this.props.totalOrder.totalWithoutTax }</p> */}
                  {this.state.totalOrder.totalWithoutTax && (
                    <p className="payment_btn_wtax">
                      Without Tax <br />
                      {this.state.totalOrder.totalWithoutTax.toFixed(2)}
                    </p>
                  )}
                  <p className="payment_btn_show">
                    SAR{" "}
                    {true
                      ? this.state.totalOrder.totalNet.toFixed(2)
                      : this.state.totalOrder.totalWithoutTax.toFixed(2)}
                  </p>
                  <p
                    style={{
                      color: "#fff",
                      lineHeight: "23px",
                      textAlign: "center",
                      marginRight: 10,
                      fontWeight: "700",
                      fontSize: 14,
                      width: "15%",
                      margin: "0",
                    }}
                  >
                    Tax
                    <br />
                    {(
                      this.state.totalOrder.totalNet -
                      this.state.totalOrder.totalWithoutTax
                    ).toFixed(2)}
                  </p>
                </div>
              </>
            ) : (
              <>
                {this.state.saleOrderTobaccoByOrder && (
                  <div id="tobacco_div">
                    <p>Tobacco Fee</p>
                    <p>
                      {" " + this.state.saleOrderTobaccoByOrder.totalNetLine}
                    </p>
                  </div>
                )}
                <span>
                  <p>
                    <span style={{ fontWeight: "bold", float: "none" }}>
                      Total Amount:
                    </span>{" "}
                    {this.state.totalOrder.totalWithoutTax}
                    <span style={{ fontWeight: "bold", float: "none" }}>
                      {" "}
                      Refund Amount:
                    </span>{" "}
                    {this.state.totalOrder.refundAmt}
                  </p>
                </span>
              </>
            )
          ) : (
            <div
              className="priceDiv"
              style={{
                height: "50px",
                cursor: "pointer",
              }}
              onClick={() => this.props.paymentScreen()}
            >
              <p style={{ fontWeight: "700", fontSize: "24" }}></p>
            </div>
          )}
          <div
            style={{
              background: "#d9d8d8",
            }}
          >
            <input
              id="focus"
              onKeyPress={(event) => {
                if (event.key === "Enter") {
                  axios({
                    url: API_URL + "productByBarcode",
                    method: "GET",
                    params: {
                      lang: localStorage.getItem("lang"),
                      clientId: localStorage.getItem("clientId"),
                      barcode: event.target.value,
                    },
                    headers: {
                      Authorization:
                        localStorage.getItem("tokenType") +
                        " " +
                        localStorage.getItem("accessToken"),
                      "Content-Type": "application/json",
                    },
                  })
                    // axios.get(API_URL + `productByBarcode?barcode=${event.target.value}&clientId=${localStorage.getItem('clientId')}&lang=${localStorage.getItem('lang')}`, )
                    .then((res) => {
                      if (res.data.length < 1) {
                        message.error("No Product found!");
                        return;
                      }
                      if (
                        res.data.length == 1 &&
                        res.data[0].isGroupProduct == false
                      ) {
                        let headers = {
                          Authorization:
                            localStorage.getItem("tokenType") +
                            " " +
                            localStorage.getItem("accessToken"),
                          "Content-Type": "application/json",
                        };
                        let authOptions = {
                          url: API_URL + "createSaleOrderLine",
                          method: "POST",
                          data: {
                            lang: localStorage.getItem("lang"),
                            client: localStorage.getItem("clientId"),
                            order: this.props.posStorage.orderId,
                            product: res.data[0].id,
                            isScaleProduct: res.data[0].isScaleProduct,
                            qty: 1,
                            uom: res.data[0].uomId,
                            isGroupProduct: false,
                            priceWithoutTax: res.data[0].priceWithoutTax,
                            unitPrice: res.data[0].price,
                            isOffer: res.data[0].isOffer,
                            prodOffer: null,
                            offerType: res.data[0].offerType,
                            isAddProduct: false,
                            actualPrice: res.data[0].price,
                            isDiscount: false,
                            items: [],
                          },
                          headers,
                        };
                        axios(authOptions).then((res) => {
                          if (res.data.success) {
                            this.setState({ notesForKitchen: null });

                            // message.success(res.data.message)
                            this.props.getsaleOrderLine();
                          } else {
                            message.error(res.data.message);
                          }
                        });
                        return;
                      }
                      if (res.data.length == 1 && res.data[0].isGroupProduct) {
                        this.props.addProduct(res.data[0].id);
                        return;
                      }
                      if (res.data.length > 1) {
                      }
                    })
                    .catch((e) => {
                      message.error("No Product found!");
                    });
                }
              }}
              style={{ fontSize: "16px" }}
              type="text"
              placeholder="Type Barcode here and press enter"
            />
          </div>
        </Card>
        {this.state.isModalOpenForKitchenNotes && (
          <Modal
            className="posAddItemModal product-modal-pop sadi4"
            title={this.props.lang.LABELS.ADD_NOTES_MODALTITLE_FORKITCHEN}
            visible={this.state.isModalOpenForKitchenNotes}
            onCancel={() => {
              this.setState({ isModalOpenForKitchenNotes: false });
            }}
            onOk={() => this.modalOpenForKitchenNotesHandleer()}
            okText={this.props.lang.OK}
            cancelText={this.props.lang.CANCEL}
          >
            <Form.Item label={this.props.lang.LABELS.NOTES}>
              {this.state.isNotesForKitchenParentLine ? (
                <Input.TextArea
                  autoSize={{ minRows: 2, maxRows: 5 }}
                  onChange={(e) =>
                    this.setState({ notesForKitchenParentLine: e.target.value })
                  }
                  value={this.state.notesForKitchenParentLine}
                  placeholder={this.props.lang.PLACEHOLDERS.NOTESFORKITCHEN}
                />
              ) : (
                <Input.TextArea
                  autoSize={{ minRows: 2, maxRows: 5 }}
                  onChange={(e) =>
                    this.setState({ notesForKitchen: e.target.value })
                  }
                  value={this.state.notesForKitchen}
                  placeholder={this.props.lang.PLACEHOLDERS.NOTESFORKITCHEN}
                />
              )}
            </Form.Item>
          </Modal>
        )}
        {this.state.visible && (
          <Modal
            className="posAddItemModal product-modal-pop extended-width product_modal_pop_my sadi5"
            title={""}
            visible={this.state.visible}
            onCancel={this.handleCancel1stModal}
            onOk={() =>
              this.state.loadingBtnAddProduct
                ? () => {}
                : this.handleOk1stModal(true)
            }
            okButtonProps={{ disabled: this.state.visibleOkButton }}
            okText={
              this.state.loadingBtnAddProduct
                ? this.props.lang.LOADING
                : this.props.lang.OK
            }
            style={{
              direction: this.props.lang.INJAZ_AUTH_DIRECTION,
              maxHeight: "80vh",
              height: "80vh",
            }}
            cancelText={this.props.lang.CANCEL}
          >
            {this.state.modalType &&
            this.state.modalType.toString() === "notes" ? (
              <Input.TextArea
                placeholder={this.props.lang.PLACEHOLDERS.NOTES}
                onChange={(e) => this.setState({ note: e.target.value })}
              />
            ) : this.state.modalType &&
              this.state.modalType.toString() === "priority" ? (
              <Select
                placeholder={this.props.lang.PLACEHOLDERS.PRERIORITY}
                onChange={(e) => this.setState({ note: e })}
                style={{ width: "100%" }}
              >
                {this.state.parameters.length > 0 &&
                  this.state.parameters.map((item) => {
                    return (
                      <Select.Option key={item.id} value={item.paramCode}>
                        {item.name}
                      </Select.Option>
                    );
                  })}
              </Select>
            ) : this.state.modalType &&
              this.state.modalType.toString() === "selectPayment" ? (
              <Select
                placeholder={this.props.lang.PLACEHOLDERS.PAY_MTHD}
                onChange={(e) => this.setState({ payment: e }, () => {})}
                style={{ width: "100%" }}
              >
                {this.state.paymethods.length > 0 &&
                  this.state.paymethods.map((item) => {
                    return (
                      <Select.Option key={item.id} value={item.id}>
                        {item.name}
                      </Select.Option>
                    );
                  })}
              </Select>
            ) : (this.state.modalType &&
                this.state.modalType.toString() === "poslineAdded") ||
              this.state.modalType.toString() === "remove" ? (
              <div className="custommodal">
                <div className="cartheader">
                  {/* <h1>{this.state.modalType.toString()}</h1> */}

                  {/* image with name */}

                  <div className="txt">
                    {this.props.productList.length > 0 &&
                      this.props.productList.filter(
                        (i) => i.id == this.state.selectedOrderLineProduct,
                      ).length > 0 &&
                      this.props.productList.filter(
                        (i) => i.id == this.state.selectedOrderLineProduct,
                      )[0].name}
                  </div>

                  <div
                    className="image"
                    style={{
                      background:
                        this.props.productList.length > 0 &&
                        this.props.productList.filter(
                          (i) => i.id == this.state.selectedOrderLineProduct,
                        ).length > 0 &&
                        this.props.productList.filter(
                          (i) => i.id == this.state.selectedOrderLineProduct,
                        )[0].imageName
                          ? `url(${API_URL}getProductImage?clientName=${localStorage.getItem(
                              "client_name",
                            )}&imageName=${this.props.productList.length > 0 &&
                              this.props.productList.filter(
                                (i) =>
                                  i.id == this.state.selectedOrderLineProduct,
                              ).length > 0 &&
                              this.props.productList.filter(
                                (i) =>
                                  i.id == this.state.selectedOrderLineProduct,
                              )[0].imageName}&imageContent=${imageContent})`
                          : "#c3c1c1",
                    }}
                  ></div>

                  <div className="txt">
                    {this.props.productList.length > 0 &&
                      this.props.productList.filter(
                        (i) => i.id == this.state.selectedOrderLineProduct,
                      ).length > 0 &&
                      this.props.productList.filter(
                        (i) => i.id == this.state.selectedOrderLineProduct,
                      )[0].nameAr}
                  </div>
                </div>

                {/* func */}

                <div className="addqty">
                  <div className="">
                    <img
                      alt="img"
                      src="/icons/note.png"
                      onClick={() => {
                        this.setState({
                          notesForKitchen:
                            this.props.posProductsLists.filter(
                              (i) =>
                                i.product ==
                                  this.state.selectedOrderLineProduct &&
                                i.id == this.state.selectedOrderLine,
                            ).length > 0 &&
                            this.props.posProductsLists.filter(
                              (i) =>
                                i.product ==
                                  this.state.selectedOrderLineProduct &&
                                i.id == this.state.selectedOrderLine,
                            )[0].notes,
                          itemSelectedForNotesKitchen: this.props.posProductsLists.filter(
                            (i) =>
                              i.product ==
                                this.state.selectedOrderLineProduct &&
                              i.id == this.state.selectedOrderLine,
                          )[0],
                          isModalOpenForKitchenNotes: true,
                        });
                      }}
                    />
                  </div>

                  <div className="incdec">
                    <Button
                      className="add"
                      onClick={() =>
                        this.props.productList.length > 0 &&
                        this.props.productList.filter(
                          (i) => i.id == this.state.selectedOrderLineProduct,
                        ).length > 0 &&
                        !this.props.productList.filter(
                          (i) => i.id == this.state.selectedOrderLineProduct,
                        )[0].isGroupProduct &&
                        this.sonQTYchange(this.state.selectedqty + 1)
                      }
                    >
                      +
                    </Button>
                    <p style={{ padding: "4px 9px", height: "32px" }}>
                      {this.state.selectedqty}
                    </p>
                    <Button
                      className="remove"
                      onClick={() => {
                        if (this.state.selectedqty > 1) {
                          this.sonQTYchange(this.state.selectedqty - 1);
                        }
                      }}
                    >
                      -
                    </Button>
                  </div>

                  {/* <div className="removediv">
                    <AiOutlineStop
                      onClick={() => this.setState({ modalType: "remove" })}
                      style={{ fontSize: '30px', color: 'red' }}
                    />
                  </div> */}
                </div>

                <div>
                  {this.state.additionalProduct.length > 0 &&
                    this.state.additionalProduct.map((item, i) => (
                      <div>
                        {/* <Switch
                          checkedChildren={1}
                          unCheckedChildren={1}

                          
                          defaultChecked={false}
                          key={i}
                        /> */}
                        <div className="subwrapper">
                          <div>
                            <Checkbox
                              size="small"
                              checked={
                                this.state.addedAdditionalItems
                                  .filter(
                                    (pro) =>
                                      pro.isAddProduct == true ||
                                      pro.isGroupItem == true,
                                  )
                                  .filter(
                                    (ii) =>
                                      ii.parentProduct ==
                                      this.state.selectedOrderLine,
                                  )
                                  .filter(
                                    (it) =>
                                      it.product == item.id &&
                                      it.uom == item.uomId,
                                  ).length > 0
                                  ? true
                                  : false
                              }
                              onChange={(e) =>
                                this.addAdditionalItemsToArray(
                                  e,
                                  item,
                                  "",
                                  this.props.posProductsLists
                                    .filter(
                                      (pro) =>
                                        pro.isAddProduct == true ||
                                        pro.isGroupItem == true,
                                    )
                                    .filter(
                                      (ii) =>
                                        ii.parentProduct ==
                                        this.state.selectedOrderLine,
                                    )
                                    .filter(
                                      (it) =>
                                        it.product == item.id &&
                                        it.uom == item.uomId,
                                    ),
                                  {
                                    min:
                                      this.props.productList.length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                            this.state
                                              .selectedOrderLineProduct &&
                                          i.isGroupProduct,
                                      ).length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                            this.state
                                              .selectedOrderLineProduct &&
                                          i.isGroupProduct,
                                      )[0].minItemQty,
                                    max:
                                      this.props.productList.length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                            this.state
                                              .selectedOrderLineProduct &&
                                          i.isGroupProduct,
                                      ).length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                            this.state
                                              .selectedOrderLineProduct &&
                                          i.isGroupProduct,
                                      )[0].maxItemQty,
                                    isGroupProduct:
                                      this.props.productList.length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                            this.state
                                              .selectedOrderLineProduct &&
                                          i.isGroupProduct,
                                      ).length > 0 &&
                                      true,
                                    items: this.props.posProductsLists,
                                    add: true,
                                  },
                                )
                              }
                            ></Checkbox>
                          </div>

                          <div className="name">
                            <p>
                              {localStorage.getItem("lang") == "EN"
                                ? item.name
                                : item.nameAr}
                            </p>
                          </div>

                          <div>
                            <p>
                              {JSON.parse(
                                localStorage.getItem("isInclusiveTax"),
                              )
                                ? item.price
                                : item.priceWithoutTax}
                            </p>
                          </div>

                          <div>
                            {this.state.addedAdditionalItems
                              .filter(
                                (pro) =>
                                  pro.isAddProduct == true ||
                                  pro.isGroupItem == true,
                              )
                              .filter(
                                (ii) =>
                                  ii.parentProduct ==
                                  this.state.selectedOrderLine,
                              )
                              .filter(
                                (it) =>
                                  it.product == item.id && it.uom == item.uomId,
                              ).length > 0 && (
                              <span style={{ display: "flex" }}>
                                <Button
                                  style={{
                                    color: "#ff364a",
                                    borderColor: "#ff364a",
                                  }}
                                  onClick={() =>
                                    this.addAdditionalItemsToArrayIncreament(
                                      { target: { checked: false } },
                                      item,
                                      this.state.addedAdditionalItems
                                        .filter(
                                          (pro) =>
                                            pro.isAddProduct == true ||
                                            pro.isGroupItem == true,
                                        )
                                        .filter(
                                          (ii) =>
                                            ii.parentProduct ==
                                            this.state.selectedOrderLine,
                                        )
                                        .filter(
                                          (it) =>
                                            it.product == item.id &&
                                            it.uom == item.uomId,
                                        )[0].qty + 1,
                                      this.props.posProductsLists
                                        .filter(
                                          (pro) =>
                                            pro.isAddProduct == true ||
                                            pro.isGroupItem == true,
                                        )
                                        .filter(
                                          (ii) =>
                                            ii.parentProduct ==
                                            this.state.selectedOrderLine,
                                        )
                                        .filter(
                                          (it) =>
                                            it.product == item.id &&
                                            it.uom == item.uomId,
                                        ),
                                      {
                                        min:
                                          this.props.productList.length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          ).length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          )[0].minItemQty,
                                        max:
                                          this.props.productList.length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          ).length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          )[0].maxItemQty,
                                        isGroupProduct:
                                          this.props.productList.length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          ).length > 0 &&
                                          true,
                                        items: this.props.posProductsLists,
                                        add: true,
                                      },
                                    )
                                  }
                                >
                                  +
                                </Button>
                                <p
                                  style={{ padding: "4px 9px", height: "32px" }}
                                >
                                  {
                                    this.state.addedAdditionalItems
                                      .filter(
                                        (pro) =>
                                          pro.isAddProduct == true ||
                                          pro.isGroupItem == true,
                                      )
                                      .filter(
                                        (ii) =>
                                          ii.parentProduct ==
                                          this.state.selectedOrderLine,
                                      )
                                      .filter(
                                        (it) =>
                                          it.product == item.id &&
                                          it.uom == item.uomId,
                                      )[0].qty
                                  }
                                </p>
                                <Button
                                  style={{
                                    color: "#ff364a",
                                    borderColor: "#ff364a",
                                  }}
                                  onClick={() =>
                                    this.addAdditionalItemsToArrayIncreament(
                                      { target: { checked: false } },
                                      item,
                                      this.state.addedAdditionalItems
                                        .filter(
                                          (pro) =>
                                            pro.isAddProduct == true ||
                                            pro.isGroupItem == true,
                                        )
                                        .filter(
                                          (ii) =>
                                            ii.parentProduct ==
                                            this.state.selectedOrderLine,
                                        )
                                        .filter(
                                          (it) =>
                                            it.product == item.id &&
                                            it.uom == item.uomId,
                                        )[0].qty - 1,
                                      this.props.posProductsLists
                                        .filter(
                                          (pro) =>
                                            pro.isAddProduct == true ||
                                            pro.isGroupItem == true,
                                        )
                                        .filter(
                                          (ii) =>
                                            ii.parentProduct ==
                                            this.state.selectedOrderLine,
                                        )
                                        .filter(
                                          (it) =>
                                            it.product == item.id &&
                                            it.uom == item.uomId,
                                        ),
                                      {
                                        min:
                                          this.props.productList.length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          ).length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          )[0].minItemQty,
                                        max:
                                          this.props.productList.length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          ).length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          )[0].maxItemQty,
                                        isGroupProduct:
                                          this.props.productList.length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          ).length > 0 &&
                                          true,
                                        items: this.props.posProductsLists,
                                        add: false,
                                      },
                                    )
                                  }
                                >
                                  -
                                </Button>
                              </span>
                            )}
                          </div>

                          <div>
                            {this.state.addedAdditionalItems.length > 0 &&
                              this.state.addedAdditionalItems.filter(
                                (pro) =>
                                  pro.isAddProduct == true ||
                                  pro.isGroupItem == true,
                              ).length > 0 &&
                              this.state.addedAdditionalItems
                                .filter(
                                  (pro) =>
                                    pro.isAddProduct == true ||
                                    pro.isGroupItem == true,
                                )
                                .filter(
                                  (ii) =>
                                    ii.parentProduct ==
                                    this.state.selectedOrderLine,
                                )
                                .filter(
                                  (it) =>
                                    it.product == item.id &&
                                    it.uom == item.uomId,
                                ).length > 0 &&
                              this.state.addedAdditionalItems
                                .filter(
                                  (pro) =>
                                    pro.isAddProduct == true ||
                                    pro.isGroupItem == true,
                                )
                                .filter(
                                  (ii) =>
                                    ii.parentProduct ==
                                    this.state.selectedOrderLine,
                                ).length > 0 && (
                                <td
                                  style={{
                                    marginRight: "0px",
                                    marginLeft: "60px",
                                  }}
                                >
                                  {this.state.addedAdditionalItems
                                    .filter(
                                      (pro) =>
                                        pro.isAddProduct == true ||
                                        pro.isGroupItem == true,
                                    )
                                    .filter(
                                      (ii) =>
                                        ii.parentProduct ==
                                        this.state.selectedOrderLine,
                                    )
                                    .filter(
                                      (it) =>
                                        it.product == item.id &&
                                        it.uom == item.uomId,
                                    )[0].qty *
                                    (JSON.parse(
                                      localStorage.getItem("isInclusiveTax"),
                                    )
                                      ? this.state.addedAdditionalItems
                                          .filter(
                                            (pro) =>
                                              pro.isAddProduct == true ||
                                              pro.isGroupItem == true,
                                          )
                                          .filter(
                                            (ii) =>
                                              ii.parentProduct ==
                                              this.state.selectedOrderLine,
                                          )
                                          .filter(
                                            (it) =>
                                              it.product == item.id &&
                                              it.uom == item.uomId,
                                          )[0].unitPrice
                                      : this.state.addedAdditionalItems
                                          .filter(
                                            (pro) =>
                                              pro.isAddProduct == true ||
                                              pro.isGroupItem == true,
                                          )
                                          .filter(
                                            (ii) =>
                                              ii.parentProduct ==
                                              this.state.selectedOrderLine,
                                          )
                                          .filter(
                                            (it) =>
                                              it.product == item.id &&
                                              it.uom == item.uomId,
                                          )[0].priceWithoutTax)}
                                </td>
                              )}
                          </div>

                          <div>
                            {this.state.addedAdditionalItems
                              .filter(
                                (pro) =>
                                  pro.isAddProduct == true ||
                                  pro.isGroupItem == true,
                              )
                              .filter(
                                (ii) =>
                                  ii.parentProduct ==
                                  this.state.selectedOrderLine,
                              )
                              .filter(
                                (it) =>
                                  it.product == item.id && it.uom == item.uomId,
                              ).length > 0 && (
                              <img
                                alt="img"
                                src="/icons/note.png"
                                style={{ width: "40px" }}
                                onClick={() => {
                                  this.state.addedAdditionalItems.length > 0 &&
                                    this.state.addedAdditionalItems.filter(
                                      (pro) =>
                                        pro.isAddProduct == true ||
                                        pro.isGroupItem == true,
                                    ).length > 0 &&
                                    this.state.addedAdditionalItems
                                      .filter(
                                        (pro) =>
                                          pro.isAddProduct == true ||
                                          pro.isGroupItem == true,
                                      )
                                      .filter(
                                        (ii) =>
                                          ii.parentProduct ==
                                          this.state.selectedOrderLine,
                                      ).length > 0 &&
                                    this.setState({
                                      notesForKitchen: null,
                                      itemSelectedForNotesKitchen: item.id,
                                      isNotesAddedOnCreate: true,
                                      isModalOpenForKitchenNotes: true,
                                    });
                                }}
                              />
                            )}
                          </div>
                        </div>

                        <tr className="addProdTD" style={{ display: "none" }}>
                          <td>
                            {/* <Checkbox
                              value={item.id}
                              key={i}
                              onChange={(e) =>
                                this.addAdditionalItemsToArray(
                                  e,
                                  item,
                                  "",
                                  this.props.posProductsLists
                                    .filter(
                                      (pro) =>
                                        pro.isAddProduct == true ||
                                        pro.isGroupItem == true
                                    )
                                    .filter(
                                      (ii) =>
                                        ii.parentProduct ==
                                        this.state.selectedOrderLine
                                    )
                                    .filter(
                                      (it) =>
                                        it.product == item.id &&
                                        it.uom == item.uomId
                                    ),
                                  {
                                    min:
                                      this.props.productList.length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                          this.state
                                            .selectedOrderLineProduct &&
                                          i.isGroupProduct
                                      ).length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                          this.state
                                            .selectedOrderLineProduct &&
                                          i.isGroupProduct
                                      )[0].minItemQty,
                                    max:
                                      this.props.productList.length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                          this.state
                                            .selectedOrderLineProduct &&
                                          i.isGroupProduct
                                      ).length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                          this.state
                                            .selectedOrderLineProduct &&
                                          i.isGroupProduct
                                      )[0].maxItemQty,
                                    isGroupProduct:
                                      this.props.productList.length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                          this.state
                                            .selectedOrderLineProduct &&
                                          i.isGroupProduct
                                      ).length > 0 &&
                                      true,
                                    items: this.props.posProductsLists,
                                    add: true,
                                  }
                                )
                              }
                              checked={
                                this.state.addedAdditionalItems
                                  .filter(
                                    (pro) =>
                                      pro.isAddProduct == true ||
                                      pro.isGroupItem == true
                                  )
                                  .filter(
                                    (ii) =>
                                      ii.parentProduct ==
                                      this.state.selectedOrderLine
                                  )
                                  .filter(
                                    (it) =>
                                      it.product == item.id &&
                                      it.uom == item.uomId
                                  ).length > 0
                                  ? true
                                  : false
                              }
                            ></Checkbox> */}

                            <Switch
                              value={item.id}
                              key={i}
                              checkedChildren={<FaCheckCircle />}
                              unCheckedChildren={<FaWindowClose />}
                              checked={
                                this.state.addedAdditionalItems
                                  .filter(
                                    (pro) =>
                                      pro.isAddProduct == true ||
                                      pro.isGroupItem == true,
                                  )
                                  .filter(
                                    (ii) =>
                                      ii.parentProduct ==
                                      this.state.selectedOrderLine,
                                  )
                                  .filter(
                                    (it) =>
                                      it.product == item.id &&
                                      it.uom == item.uomId,
                                  ).length > 0
                                  ? true
                                  : false
                              }
                              onChange={(e) =>
                                this.addAdditionalItemsToArray(
                                  e,
                                  item,
                                  "",
                                  this.props.posProductsLists
                                    .filter(
                                      (pro) =>
                                        pro.isAddProduct == true ||
                                        pro.isGroupItem == true,
                                    )
                                    .filter(
                                      (ii) =>
                                        ii.parentProduct ==
                                        this.state.selectedOrderLine,
                                    )
                                    .filter(
                                      (it) =>
                                        it.product == item.id &&
                                        it.uom == item.uomId,
                                    ),
                                  {
                                    min:
                                      this.props.productList.length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                            this.state
                                              .selectedOrderLineProduct &&
                                          i.isGroupProduct,
                                      ).length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                            this.state
                                              .selectedOrderLineProduct &&
                                          i.isGroupProduct,
                                      )[0].minItemQty,
                                    max:
                                      this.props.productList.length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                            this.state
                                              .selectedOrderLineProduct &&
                                          i.isGroupProduct,
                                      ).length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                            this.state
                                              .selectedOrderLineProduct &&
                                          i.isGroupProduct,
                                      )[0].maxItemQty,
                                    isGroupProduct:
                                      this.props.productList.length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                            this.state
                                              .selectedOrderLineProduct &&
                                          i.isGroupProduct,
                                      ).length > 0 &&
                                      true,
                                    items: this.props.posProductsLists,
                                    add: true,
                                  },
                                )
                              }
                            />
                          </td>
                          <td>
                            {localStorage.getItem("lang") == "EN"
                              ? item.name
                              : item.nameAr}
                          </td>
                          <td>
                            {JSON.parse(localStorage.getItem("isInclusiveTax"))
                              ? item.price
                              : item.priceWithoutTax}
                          </td>
                          <td>
                            {this.state.addedAdditionalItems
                              .filter(
                                (pro) =>
                                  pro.isAddProduct == true ||
                                  pro.isGroupItem == true,
                              )
                              .filter(
                                (ii) =>
                                  ii.parentProduct ==
                                  this.state.selectedOrderLine,
                              )
                              .filter(
                                (it) =>
                                  it.product == item.id && it.uom == item.uomId,
                              ).length > 0 && (
                              <span style={{ display: "flex" }}>
                                <Button
                                  style={{
                                    color: "#ff364a",
                                    borderColor: "#ff364a",
                                  }}
                                  onClick={() =>
                                    this.addAdditionalItemsToArrayIncreament(
                                      { target: { checked: false } },
                                      item,
                                      this.state.addedAdditionalItems
                                        .filter(
                                          (pro) =>
                                            pro.isAddProduct == true ||
                                            pro.isGroupItem == true,
                                        )
                                        .filter(
                                          (ii) =>
                                            ii.parentProduct ==
                                            this.state.selectedOrderLine,
                                        )
                                        .filter(
                                          (it) =>
                                            it.product == item.id &&
                                            it.uom == item.uomId,
                                        )[0].qty + 1,
                                      this.props.posProductsLists
                                        .filter(
                                          (pro) =>
                                            pro.isAddProduct == true ||
                                            pro.isGroupItem == true,
                                        )
                                        .filter(
                                          (ii) =>
                                            ii.parentProduct ==
                                            this.state.selectedOrderLine,
                                        )
                                        .filter(
                                          (it) =>
                                            it.product == item.id &&
                                            it.uom == item.uomId,
                                        ),
                                      {
                                        min:
                                          this.props.productList.length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          ).length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          )[0].minItemQty,
                                        max:
                                          this.props.productList.length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          ).length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          )[0].maxItemQty,
                                        isGroupProduct:
                                          this.props.productList.length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          ).length > 0 &&
                                          true,
                                        items: this.props.posProductsLists,
                                        add: true,
                                      },
                                    )
                                  }
                                >
                                  +
                                </Button>
                                <p
                                  style={{ padding: "4px 9px", height: "32px" }}
                                >
                                  {
                                    this.state.addedAdditionalItems
                                      .filter(
                                        (pro) =>
                                          pro.isAddProduct == true ||
                                          pro.isGroupItem == true,
                                      )
                                      .filter(
                                        (ii) =>
                                          ii.parentProduct ==
                                          this.state.selectedOrderLine,
                                      )
                                      .filter(
                                        (it) =>
                                          it.product == item.id &&
                                          it.uom == item.uomId,
                                      )[0].qty
                                  }
                                </p>
                                <Button
                                  style={{
                                    color: "#ff364a",
                                    borderColor: "#ff364a",
                                  }}
                                  onClick={() =>
                                    this.addAdditionalItemsToArrayIncreament(
                                      { target: { checked: false } },
                                      item,
                                      this.state.addedAdditionalItems
                                        .filter(
                                          (pro) =>
                                            pro.isAddProduct == true ||
                                            pro.isGroupItem == true,
                                        )
                                        .filter(
                                          (ii) =>
                                            ii.parentProduct ==
                                            this.state.selectedOrderLine,
                                        )
                                        .filter(
                                          (it) =>
                                            it.product == item.id &&
                                            it.uom == item.uomId,
                                        )[0].qty - 1,
                                      this.props.posProductsLists
                                        .filter(
                                          (pro) =>
                                            pro.isAddProduct == true ||
                                            pro.isGroupItem == true,
                                        )
                                        .filter(
                                          (ii) =>
                                            ii.parentProduct ==
                                            this.state.selectedOrderLine,
                                        )
                                        .filter(
                                          (it) =>
                                            it.product == item.id &&
                                            it.uom == item.uomId,
                                        ),
                                      {
                                        min:
                                          this.props.productList.length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          ).length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          )[0].minItemQty,
                                        max:
                                          this.props.productList.length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          ).length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          )[0].maxItemQty,
                                        isGroupProduct:
                                          this.props.productList.length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          ).length > 0 &&
                                          true,
                                        items: this.props.posProductsLists,
                                        add: false,
                                      },
                                    )
                                  }
                                >
                                  -
                                </Button>
                              </span>
                            )}
                          </td>
                          {this.state.addedAdditionalItems.length > 0 &&
                            this.state.addedAdditionalItems.filter(
                              (pro) =>
                                pro.isAddProduct == true ||
                                pro.isGroupItem == true,
                            ).length > 0 &&
                            this.state.addedAdditionalItems
                              .filter(
                                (pro) =>
                                  pro.isAddProduct == true ||
                                  pro.isGroupItem == true,
                              )
                              .filter(
                                (ii) =>
                                  ii.parentProduct ==
                                  this.state.selectedOrderLine,
                              )
                              .filter(
                                (it) =>
                                  it.product == item.id && it.uom == item.uomId,
                              ).length > 0 &&
                            this.state.addedAdditionalItems
                              .filter(
                                (pro) =>
                                  pro.isAddProduct == true ||
                                  pro.isGroupItem == true,
                              )
                              .filter(
                                (ii) =>
                                  ii.parentProduct ==
                                  this.state.selectedOrderLine,
                              ).length > 0 && (
                              <td
                                style={{
                                  marginRight: "0px",
                                  marginLeft: "60px",
                                }}
                              >
                                {this.state.addedAdditionalItems
                                  .filter(
                                    (pro) =>
                                      pro.isAddProduct == true ||
                                      pro.isGroupItem == true,
                                  )
                                  .filter(
                                    (ii) =>
                                      ii.parentProduct ==
                                      this.state.selectedOrderLine,
                                  )
                                  .filter(
                                    (it) =>
                                      it.product == item.id &&
                                      it.uom == item.uomId,
                                  )[0].qty *
                                  (JSON.parse(
                                    localStorage.getItem("isInclusiveTax"),
                                  )
                                    ? this.state.addedAdditionalItems
                                        .filter(
                                          (pro) =>
                                            pro.isAddProduct == true ||
                                            pro.isGroupItem == true,
                                        )
                                        .filter(
                                          (ii) =>
                                            ii.parentProduct ==
                                            this.state.selectedOrderLine,
                                        )
                                        .filter(
                                          (it) =>
                                            it.product == item.id &&
                                            it.uom == item.uomId,
                                        )[0].unitPrice
                                    : this.state.addedAdditionalItems
                                        .filter(
                                          (pro) =>
                                            pro.isAddProduct == true ||
                                            pro.isGroupItem == true,
                                        )
                                        .filter(
                                          (ii) =>
                                            ii.parentProduct ==
                                            this.state.selectedOrderLine,
                                        )
                                        .filter(
                                          (it) =>
                                            it.product == item.id &&
                                            it.uom == item.uomId,
                                        )[0].priceWithoutTax)}
                              </td>
                            )}
                          {/* // total price */}
                          {this.state.addedAdditionalItems
                            .filter(
                              (pro) =>
                                pro.isAddProduct == true ||
                                pro.isGroupItem == true,
                            )
                            .filter(
                              (ii) =>
                                ii.parentProduct ==
                                this.state.selectedOrderLine,
                            )
                            .filter(
                              (it) =>
                                it.product == item.id && it.uom == item.uomId,
                            ).length > 0 && (
                            <td>
                              <Button
                                onClick={() => {
                                  this.state.addedAdditionalItems.length > 0 &&
                                    this.state.addedAdditionalItems.filter(
                                      (pro) =>
                                        pro.isAddProduct == true ||
                                        pro.isGroupItem == true,
                                    ).length > 0 &&
                                    this.state.addedAdditionalItems
                                      .filter(
                                        (pro) =>
                                          pro.isAddProduct == true ||
                                          pro.isGroupItem == true,
                                      )
                                      .filter(
                                        (ii) =>
                                          ii.parentProduct ==
                                          this.state.selectedOrderLine,
                                      ).length > 0 &&
                                    this.setState({
                                      notesForKitchen: null,
                                      itemSelectedForNotesKitchen: item.id,
                                      isNotesAddedOnCreate: true,
                                      isModalOpenForKitchenNotes: true,
                                    });
                                }}
                              >
                                Add +
                              </Button>
                            </td>
                          )}
                        </tr>
                      </div>
                    ))}
                </div>

                <Row style={{ display: "none" }}>
                  <Col span={4}>{this.props.lang.TABLEHEADERS.PNAME}</Col>
                  <Col span={6}>{this.props.lang.TABLEHEADERS.PQTY}</Col>
                  <Col span={5}>{this.props.lang.TABLEHEADERS.PPRICE}</Col>
                  <Col span={5}>{this.props.lang.TABLEHEADERS.PACTION}</Col>
                  <Col span={4}></Col>
                  <Col span={4}></Col>
                </Row>
                {this.state.modalType &&
                  this.state.modalType.toString() === "poslineAdded" && (
                    <Row style={{ display: "none" }}>
                      <Col span={4}>
                        {this.props.productList.length > 0 &&
                          this.props.productList.filter(
                            (i) => i.id == this.state.selectedOrderLineProduct,
                          ).length > 0 &&
                          this.props.productList.filter(
                            (i) => i.id == this.state.selectedOrderLineProduct,
                          )[0].name}
                      </Col>
                      <Col span={6}>
                        <span style={{ display: "flex" }}>
                          <Button
                            style={{ color: "#ff364a", borderColor: "#ff364a" }}
                            onClick={() =>
                              this.props.productList.length > 0 &&
                              this.props.productList.filter(
                                (i) =>
                                  i.id == this.state.selectedOrderLineProduct,
                              ).length > 0 &&
                              !this.props.productList.filter(
                                (i) =>
                                  i.id == this.state.selectedOrderLineProduct,
                              )[0].isGroupProduct &&
                              this.sonQTYchange(this.state.selectedqty + 1)
                            }
                          >
                            +
                          </Button>
                          <p style={{ padding: "4px 9px", height: "32px" }}>
                            {this.state.selectedqty}
                          </p>
                          <Button
                            style={{ color: "#ff364a", borderColor: "#ff364a" }}
                            onClick={() => {
                              if (this.state.selectedqty > 1) {
                                this.sonQTYchange(this.state.selectedqty - 1);
                              }
                            }}
                          >
                            -
                          </Button>
                        </span>
                      </Col>
                      <Col span={5}>
                        <InputNumber
                          value={
                            (JSON.parse(localStorage.getItem("isInclusiveTax"))
                              ? this.state.selectedOrderLineUnitPrice
                              : this.state
                                  .selectedOrderLineUnitPriceWithoutTax) *
                            this.state.selectedqty
                          }
                          onChange={(v) => {
                            let minPrice = this.props.productList.filter(
                              (i) =>
                                i.id == this.state.selectedOrderLineProduct,
                            )[0].minPrice;
                            if (v >= minPrice) {
                              if (
                                JSON.parse(
                                  localStorage.getItem("isInclusiveTax"),
                                )
                              ) {
                                this.setState({
                                  selectedOrderLineUnitPrice: v,
                                  selectedqty: 1,
                                });
                              } else {
                                this.setState({
                                  selectedOrderLineUnitPriceWithoutTax: v,
                                  selectedqty: 1,
                                });
                              }
                            }
                          }}
                        />
                      </Col>
                      <Col span={5}>
                        <Button
                          onClick={() => this.setState({ modalType: "remove" })}
                          style={{ background: "#cc0000", color: "#fff" }}
                        >
                          {" "}
                          Remove{" "}
                        </Button>
                      </Col>
                      <Col span={4}>
                        <Button
                          onClick={() => {
                            this.state.addedAdditionalItems.length > 0 &&
                              this.state.addedAdditionalItems.filter(
                                (pro) =>
                                  pro.isAddProduct == true ||
                                  pro.isGroupItem == true,
                              ).length > 0 &&
                              this.state.addedAdditionalItems
                                .filter(
                                  (pro) =>
                                    pro.isAddProduct == true ||
                                    pro.isGroupItem == true,
                                )
                                .filter(
                                  (ii) =>
                                    ii.parentProduct ==
                                    this.state.selectedOrderLine,
                                ).length > 0 &&
                              this.setState({
                                notesForKitchen: null,
                                itemSelectedForNotesKitchen: this.state
                                  .selectedOrderLine,
                                isNotesAddedOnCreate: true,
                                isNotesAddedOnCreateParent: true,
                                isModalOpenForKitchenNotes: true,
                              });
                          }}
                        >
                          Add +
                        </Button>
                      </Col>
                    </Row>
                  )}
                <Row gutter={24} style={{ display: "none" }}>
                  <Col span={24}>
                    {this.state.addedAdditionalItemsParent.isScaleProduct && (
                      <Button
                        size="small"
                        onClick={() =>
                          this.setState({
                            qtyCalculator: true,
                            amountPay: this.state.selectedqty,
                          })
                        }
                      >
                        Calculator
                      </Button>
                    )}
                  </Col>
                </Row>
                {/* <h2>
                  {this.state.isGroupProduct
                    ? "Group Items"
                    : "Add on Products"}
                </h2> */}
                <table style={{ display: "none" }}>
                  <thead>
                    <tr className="addProdTR">
                      <label className="ant-checkbox-wrapper">
                        <span className="ant-checkbox">
                          <span
                            className="ant-checkbox-inner"
                            style={{ display: "none" }}
                          ></span>
                        </span>
                        <span>
                          <th></th>
                          <th>{this.props.lang.TABLEHEADERS.PNAME}</th>
                          <th>{this.props.lang.TABLEHEADERS.PUPRICE}</th>
                          <th>{this.props.lang.TABLEHEADERS.PQTY_SHORT}</th>
                          <th
                            style={{ marginRight: "0px", marginLeft: "60px" }}
                          >
                            {this.props.lang.TABLEHEADERS.PTPRICE}
                          </th>
                        </span>
                      </label>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.additionalProduct.length > 0 &&
                      this.state.additionalProduct.map((item, i) => (
                        <tr className="addProdTD">
                          <td>
                            <Checkbox
                              value={item.id}
                              key={i}
                              onChange={(e) =>
                                this.addAdditionalItemsToArray(
                                  e,
                                  item,
                                  "",
                                  this.props.posProductsLists
                                    .filter(
                                      (pro) =>
                                        pro.isAddProduct == true ||
                                        pro.isGroupItem == true,
                                    )
                                    .filter(
                                      (ii) =>
                                        ii.parentProduct ==
                                        this.state.selectedOrderLine,
                                    )
                                    .filter(
                                      (it) =>
                                        it.product == item.id &&
                                        it.uom == item.uomId,
                                    ),
                                  {
                                    min:
                                      this.props.productList.length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                            this.state
                                              .selectedOrderLineProduct &&
                                          i.isGroupProduct,
                                      ).length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                            this.state
                                              .selectedOrderLineProduct &&
                                          i.isGroupProduct,
                                      )[0].minItemQty,
                                    max:
                                      this.props.productList.length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                            this.state
                                              .selectedOrderLineProduct &&
                                          i.isGroupProduct,
                                      ).length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                            this.state
                                              .selectedOrderLineProduct &&
                                          i.isGroupProduct,
                                      )[0].maxItemQty,
                                    isGroupProduct:
                                      this.props.productList.length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                            this.state
                                              .selectedOrderLineProduct &&
                                          i.isGroupProduct,
                                      ).length > 0 &&
                                      true,
                                    items: this.props.posProductsLists,
                                    add: true,
                                  },
                                )
                              }
                              checked={
                                this.state.addedAdditionalItems
                                  .filter(
                                    (pro) =>
                                      pro.isAddProduct == true ||
                                      pro.isGroupItem == true,
                                  )
                                  .filter(
                                    (ii) =>
                                      ii.parentProduct ==
                                      this.state.selectedOrderLine,
                                  )
                                  .filter(
                                    (it) =>
                                      it.product == item.id &&
                                      it.uom == item.uomId,
                                  ).length > 0
                                  ? true
                                  : false
                              }
                            ></Checkbox>
                          </td>
                          <td>
                            {localStorage.getItem("lang") == "EN"
                              ? item.name
                              : item.nameAr}
                          </td>
                          <td>
                            {JSON.parse(localStorage.getItem("isInclusiveTax"))
                              ? item.price
                              : item.priceWithoutTax}
                          </td>
                          <td>
                            {this.state.addedAdditionalItems
                              .filter(
                                (pro) =>
                                  pro.isAddProduct == true ||
                                  pro.isGroupItem == true,
                              )
                              .filter(
                                (ii) =>
                                  ii.parentProduct ==
                                  this.state.selectedOrderLine,
                              )
                              .filter(
                                (it) =>
                                  it.product == item.id && it.uom == item.uomId,
                              ).length > 0 && (
                              <span style={{ display: "flex" }}>
                                <Button
                                  style={{
                                    color: "#ff364a",
                                    borderColor: "#ff364a",
                                  }}
                                  onClick={() =>
                                    this.addAdditionalItemsToArrayIncreament(
                                      { target: { checked: false } },
                                      item,
                                      this.state.addedAdditionalItems
                                        .filter(
                                          (pro) =>
                                            pro.isAddProduct == true ||
                                            pro.isGroupItem == true,
                                        )
                                        .filter(
                                          (ii) =>
                                            ii.parentProduct ==
                                            this.state.selectedOrderLine,
                                        )
                                        .filter(
                                          (it) =>
                                            it.product == item.id &&
                                            it.uom == item.uomId,
                                        )[0].qty + 1,
                                      this.props.posProductsLists
                                        .filter(
                                          (pro) =>
                                            pro.isAddProduct == true ||
                                            pro.isGroupItem == true,
                                        )
                                        .filter(
                                          (ii) =>
                                            ii.parentProduct ==
                                            this.state.selectedOrderLine,
                                        )
                                        .filter(
                                          (it) =>
                                            it.product == item.id &&
                                            it.uom == item.uomId,
                                        ),
                                      {
                                        min:
                                          this.props.productList.length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          ).length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          )[0].minItemQty,
                                        max:
                                          this.props.productList.length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          ).length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          )[0].maxItemQty,
                                        isGroupProduct:
                                          this.props.productList.length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          ).length > 0 &&
                                          true,
                                        items: this.props.posProductsLists,
                                        add: true,
                                      },
                                    )
                                  }
                                >
                                  +
                                </Button>
                                <p
                                  style={{ padding: "4px 9px", height: "32px" }}
                                >
                                  {
                                    this.state.addedAdditionalItems
                                      .filter(
                                        (pro) =>
                                          pro.isAddProduct == true ||
                                          pro.isGroupItem == true,
                                      )
                                      .filter(
                                        (ii) =>
                                          ii.parentProduct ==
                                          this.state.selectedOrderLine,
                                      )
                                      .filter(
                                        (it) =>
                                          it.product == item.id &&
                                          it.uom == item.uomId,
                                      )[0].qty
                                  }
                                </p>
                                <Button
                                  style={{
                                    color: "#ff364a",
                                    borderColor: "#ff364a",
                                  }}
                                  onClick={() =>
                                    this.addAdditionalItemsToArrayIncreament(
                                      { target: { checked: false } },
                                      item,
                                      this.state.addedAdditionalItems
                                        .filter(
                                          (pro) =>
                                            pro.isAddProduct == true ||
                                            pro.isGroupItem == true,
                                        )
                                        .filter(
                                          (ii) =>
                                            ii.parentProduct ==
                                            this.state.selectedOrderLine,
                                        )
                                        .filter(
                                          (it) =>
                                            it.product == item.id &&
                                            it.uom == item.uomId,
                                        )[0].qty - 1,
                                      this.props.posProductsLists
                                        .filter(
                                          (pro) =>
                                            pro.isAddProduct == true ||
                                            pro.isGroupItem == true,
                                        )
                                        .filter(
                                          (ii) =>
                                            ii.parentProduct ==
                                            this.state.selectedOrderLine,
                                        )
                                        .filter(
                                          (it) =>
                                            it.product == item.id &&
                                            it.uom == item.uomId,
                                        ),
                                      {
                                        min:
                                          this.props.productList.length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          ).length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          )[0].minItemQty,
                                        max:
                                          this.props.productList.length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          ).length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          )[0].maxItemQty,
                                        isGroupProduct:
                                          this.props.productList.length > 0 &&
                                          this.props.productList.filter(
                                            (i) =>
                                              i.id ==
                                                this.state
                                                  .selectedOrderLineProduct &&
                                              i.isGroupProduct,
                                          ).length > 0 &&
                                          true,
                                        items: this.props.posProductsLists,
                                        add: false,
                                      },
                                    )
                                  }
                                >
                                  -
                                </Button>
                              </span>
                            )}
                          </td>
                          {this.state.addedAdditionalItems.length > 0 &&
                            this.state.addedAdditionalItems.filter(
                              (pro) =>
                                pro.isAddProduct == true ||
                                pro.isGroupItem == true,
                            ).length > 0 &&
                            this.state.addedAdditionalItems
                              .filter(
                                (pro) =>
                                  pro.isAddProduct == true ||
                                  pro.isGroupItem == true,
                              )
                              .filter(
                                (ii) =>
                                  ii.parentProduct ==
                                  this.state.selectedOrderLine,
                              )
                              .filter(
                                (it) =>
                                  it.product == item.id && it.uom == item.uomId,
                              ).length > 0 &&
                            this.state.addedAdditionalItems
                              .filter(
                                (pro) =>
                                  pro.isAddProduct == true ||
                                  pro.isGroupItem == true,
                              )
                              .filter(
                                (ii) =>
                                  ii.parentProduct ==
                                  this.state.selectedOrderLine,
                              ).length > 0 && (
                              <td
                                style={{
                                  marginRight: "0px",
                                  marginLeft: "60px",
                                }}
                              >
                                {this.state.addedAdditionalItems
                                  .filter(
                                    (pro) =>
                                      pro.isAddProduct == true ||
                                      pro.isGroupItem == true,
                                  )
                                  .filter(
                                    (ii) =>
                                      ii.parentProduct ==
                                      this.state.selectedOrderLine,
                                  )
                                  .filter(
                                    (it) =>
                                      it.product == item.id &&
                                      it.uom == item.uomId,
                                  )[0].qty *
                                  (JSON.parse(
                                    localStorage.getItem("isInclusiveTax"),
                                  )
                                    ? this.state.addedAdditionalItems
                                        .filter(
                                          (pro) =>
                                            pro.isAddProduct == true ||
                                            pro.isGroupItem == true,
                                        )
                                        .filter(
                                          (ii) =>
                                            ii.parentProduct ==
                                            this.state.selectedOrderLine,
                                        )
                                        .filter(
                                          (it) =>
                                            it.product == item.id &&
                                            it.uom == item.uomId,
                                        )[0].unitPrice
                                    : this.state.addedAdditionalItems
                                        .filter(
                                          (pro) =>
                                            pro.isAddProduct == true ||
                                            pro.isGroupItem == true,
                                        )
                                        .filter(
                                          (ii) =>
                                            ii.parentProduct ==
                                            this.state.selectedOrderLine,
                                        )
                                        .filter(
                                          (it) =>
                                            it.product == item.id &&
                                            it.uom == item.uomId,
                                        )[0].priceWithoutTax)}
                              </td>
                            )}
                          {this.state.addedAdditionalItems
                            .filter(
                              (pro) =>
                                pro.isAddProduct == true ||
                                pro.isGroupItem == true,
                            )
                            .filter(
                              (ii) =>
                                ii.parentProduct ==
                                this.state.selectedOrderLine,
                            )
                            .filter(
                              (it) =>
                                it.product == item.id && it.uom == item.uomId,
                            ).length > 0 && (
                            <td>
                              <Button
                                onClick={() => {
                                  this.state.addedAdditionalItems.length > 0 &&
                                    this.state.addedAdditionalItems.filter(
                                      (pro) =>
                                        pro.isAddProduct == true ||
                                        pro.isGroupItem == true,
                                    ).length > 0 &&
                                    this.state.addedAdditionalItems
                                      .filter(
                                        (pro) =>
                                          pro.isAddProduct == true ||
                                          pro.isGroupItem == true,
                                      )
                                      .filter(
                                        (ii) =>
                                          ii.parentProduct ==
                                          this.state.selectedOrderLine,
                                      ).length > 0 &&
                                    this.setState({
                                      notesForKitchen: null,
                                      itemSelectedForNotesKitchen: item.id,
                                      isNotesAddedOnCreate: true,
                                      isModalOpenForKitchenNotes: true,
                                    });
                                }}
                              >
                                Add +
                              </Button>
                            </td>
                          )}
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            ) : (
              ""
            )}
          </Modal>
        )}
        {this.state.visible2 && (
          <Modal
            className="posAddItemModal product-modal-pop extended-width sadi1"
            title={""}
            visible={this.state.visible2}
            onCancel={this.handleCancel}
            onOk={() => this.handleOk(true)}
            okText={this.props.lang.OK}
            cancelText={this.props.lang.CANCEL}
            style={{
              direction: this.props.lang.INJAZ_AUTH_DIRECTION,
              maxHeight: "80vh",
              height: "80vh",
            }}
          >
            {this.state.modalType &&
            this.state.modalType.toString() === "notes" ? (
              <Input.TextArea
                placeholder="Wrte note"
                onChange={(e) => this.setState({ note: e.target.value })}
              />
            ) : this.state.modalType &&
              this.state.modalType.toString() === "priority" ? (
              <Select
                placeholder={this.props.lang.PLACEHOLDERS.PRERIORITY}
                onChange={(e) => this.setState({ note: e })}
                style={{ width: "100%" }}
              >
                {this.state.parameters.length > 0 &&
                  this.state.parameters.map((item) => {
                    return (
                      <Select.Option key={item.id} value={item.paramCode}>
                        {item.name}
                      </Select.Option>
                    );
                  })}
              </Select>
            ) : this.state.modalType &&
              this.state.modalType.toString() === "selectPayment" ? (
              <Select
                placeholder={this.props.lang.PLACEHOLDERS.PAY_MTHD}
                onChange={(e) => this.setState({ payment: e }, () => {})}
                style={{ width: "100%" }}
              >
                {this.state.paymethods.length > 0 &&
                  this.state.paymethods.map((item) => {
                    return (
                      <Select.Option key={item.id} value={item.id}>
                        {item.name}
                      </Select.Option>
                    );
                  })}
              </Select>
            ) : (this.state.modalType &&
                this.state.modalType.toString() === "poslineAdded") ||
              this.state.modalType.toString() === "remove" ? (
              <React.Fragment>
                <div className="cartheader ">
                  <div className="txt">
                    {this.props.productList.length > 0 &&
                      this.props.productList.filter(
                        (i) => i.id == this.state.selectedOrderLineProduct,
                      ).length > 0 &&
                      this.props.productList.filter(
                        (i) => i.id == this.state.selectedOrderLineProduct,
                      )[0].name}
                  </div>
                  <div
                    className="image"
                    style={{
                      background:
                        this.props.productList.filter(
                          (i) => i.id == this.state.selectedOrderLineProduct,
                        )[0].imageName != null
                          ? `url(${API_URL}getProductImage?clientName=${localStorage.getItem(
                              "client_name",
                            )}&imageName=${
                              this.props.productList.filter(
                                (i) =>
                                  i.id == this.state.selectedOrderLineProduct,
                              )[0].imageName
                            }&imageContent=${imageContent})`
                          : "#c3c1c1",
                    }}
                  >
                    {/* <h1>{this.props.productList.filter((i) => i.id == this.state.selectedOrderLineProduct)[0].imageName}</h1> */}
                  </div>

                  <div className="txt">
                    {this.props.productList.length > 0 &&
                      this.props.productList.filter(
                        (i) => i.id == this.state.selectedOrderLineProduct,
                      ).length > 0 &&
                      this.props.productList.filter(
                        (i) => i.id == this.state.selectedOrderLineProduct,
                      )[0].nameAr}
                  </div>
                </div>
                <div className="data">
                  <div className="imagewrap2">
                    <img
                      src="/icons/note.png"
                      alt="note"
                      onClick={() => {
                        this.setState({
                          notesForKitchen:
                            this.props.posProductsLists.filter(
                              (i) =>
                                i.product ==
                                  this.state.selectedOrderLineProduct &&
                                i.id == this.state.selectedOrderLine,
                            ).length > 0 &&
                            this.props.posProductsLists.filter(
                              (i) =>
                                i.product ==
                                  this.state.selectedOrderLineProduct &&
                                i.id == this.state.selectedOrderLine,
                            )[0].notes,
                          itemSelectedForNotesKitchen: this.props.posProductsLists.filter(
                            (i) =>
                              i.product ==
                                this.state.selectedOrderLineProduct &&
                              i.id == this.state.selectedOrderLine,
                          )[0],
                          isModalOpenForKitchenNotes: true,
                        });
                      }}
                    />
                  </div>

                  <div className="count">
                    <button
                      style={{ color: "#008000", borderColor: "#008000" }}
                      onClick={() =>
                        this.props.productList.length > 0 &&
                        this.props.productList.filter(
                          (i) => i.id == this.state.selectedOrderLineProduct,
                        ).length > 0 &&
                        !this.props.productList.filter(
                          (i) => i.id == this.state.selectedOrderLineProduct,
                        )[0].isGroupProduct &&
                        this.sonQTYchange(this.state.selectedqty + 1)
                      }
                    >
                      +
                    </button>
                    <p style={{ padding: "4px 9px", height: "32px" }}>
                      {this.state.selectedqty}
                    </p>
                    <button
                      style={{ color: "#008000", borderColor: "#008000" }}
                      onClick={() => {
                        if (this.state.selectedqty > 1) {
                          this.sonQTYchange(this.state.selectedqty - 1);
                        }
                      }}
                    >
                      -
                    </button>
                  </div>
                  <div>
                    <Popover
                      content={
                        <div className="cancelItempopOver">
                          <li
                            onClick={() =>
                              this.cancelOrderItem(
                                this.props.posProductsLists.filter(
                                  (i) => i.id === this.state.selectedOrderLine,
                                ),
                                true,
                              )
                            }
                          >
                            {this.props.lang.LABELS.CANCEL_ITEM_DONOT_LOSS_}
                          </li>
                          <li
                            onClick={() =>
                              this.cancelOrderItem(
                                this.props.posProductsLists.filter(
                                  (i) => i.id === this.state.selectedOrderLine,
                                ),
                                false,
                              )
                            }
                          >
                            {this.props.lang.LABELS.CANCEL_ITEM_LOSS}
                          </li>
                        </div>
                      }
                      title={this.props.lang.LABELS.CANCEL_ITEM_POPOVER}
                      trigger="click"
                      visible={this.state.popoverVisible}
                    >
                      <button
                        className="btnRemoveProductFromCasher"
                        onClick={() => {
                          if (
                            this.props.posProductsLists.filter(
                              (i) => i.id === this.state.selectedOrderLine,
                            )[0].status == "K"
                          ) {
                            this.setState({ popoverVisible: true });
                          } else {
                            this.cancelOrderItem(
                              this.props.posProductsLists.filter(
                                (i) => i.id === this.state.selectedOrderLine,
                              ),
                              true,
                            );
                          }
                        }}
                      >
                        <FaTrash size={20} />
                      </button>
                    </Popover>
                  </div>
                </div>

                {/* <Row>
                  <Col span={4}>{this.props.lang.TABLEHEADERS.PNAME}</Col>
                  <Col span={4}>{this.props.lang.TABLEHEADERS.PQTY}</Col>
                  <Col span={4}>{this.props.lang.TABLEHEADERS.PPRICE}</Col>
                  <Col span={4}>{this.props.lang.TABLEHEADERS.PACTION}</Col>
                </Row> */}
                {this.state.modalType &&
                  this.state.modalType.toString() === "poslineAdded" && (
                    <Row style={{ display: "none" }}>
                      <Col span={4}>
                        {this.props.productList.length > 0 &&
                          this.props.productList.filter(
                            (i) => i.id == this.state.selectedOrderLineProduct,
                          ).length > 0 &&
                          this.props.productList.filter(
                            (i) => i.id == this.state.selectedOrderLineProduct,
                          )[0].name}
                      </Col>
                      <Col span={4}>
                        <span style={{ display: "flex" }}>
                          <Button
                            style={{ color: "#008000", borderColor: "#008000" }}
                            onClick={() =>
                              this.props.productList.length > 0 &&
                              this.props.productList.filter(
                                (i) =>
                                  i.id == this.state.selectedOrderLineProduct,
                              ).length > 0 &&
                              !this.props.productList.filter(
                                (i) =>
                                  i.id == this.state.selectedOrderLineProduct,
                              )[0].isGroupProduct &&
                              this.sonQTYchange(this.state.selectedqty + 1)
                            }
                          >
                            +
                          </Button>
                          <p style={{ padding: "4px 9px", height: "32px" }}>
                            {this.state.selectedqty}
                          </p>
                          <Button
                            style={{ color: "#008000", borderColor: "#008000" }}
                            onClick={() => {
                              if (this.state.selectedqty > 1) {
                                this.sonQTYchange(this.state.selectedqty - 1);
                              }
                            }}
                          >
                            -
                          </Button>
                        </span>
                        {/* <InputNumber value={this.state.selectedqty} onChange={(v) => this.sonQTYchange(v)} /> */}
                      </Col>
                      <Col span={1}></Col>
                      {JSON.parse(localStorage.getItem("userData"))
                        .roles.split(",")
                        .includes("DISCOUNT_ROLE") ? (
                        <Col span={3}>
                          {JSON.parse(
                            localStorage.getItem("isInclusiveTax"),
                          ) ? (
                            <InputNumber
                              onChange={(value) => {
                                let v = value / Number(this.state.selectedqty);

                                let minPrice = this.props.productList.filter(
                                  (i) =>
                                    i.id == this.state.selectedOrderLineProduct,
                                )[0].minPrice;
                                if (v >= minPrice) {
                                  if (
                                    JSON.parse(
                                      localStorage.getItem("isInclusiveTax"),
                                    )
                                  ) {
                                    this.setState({
                                      selectedOrderLineUnitPrice: v,
                                    });
                                  } else {
                                    this.setState({
                                      selectedOrderLineUnitPriceWithoutTax: v,
                                    });
                                  }
                                }
                              }}
                              value={
                                Number(this.state.selectedOrderLineUnitPrice) *
                                Number(this.state.selectedqty)
                              }
                            />
                          ) : (
                            <InputNumber
                              onChange={(value) => {
                                let v = value / Number(this.state.selectedqty);

                                let minPrice = this.props.productList.filter(
                                  (i) =>
                                    i.id == this.state.selectedOrderLineProduct,
                                )[0].minPrice;
                                if (v >= minPrice) {
                                  if (
                                    JSON.parse(
                                      localStorage.getItem("isInclusiveTax"),
                                    )
                                  ) {
                                    this.setState({
                                      selectedOrderLineUnitPrice: v,
                                    });
                                  } else {
                                    this.setState({
                                      selectedOrderLineUnitPriceWithoutTax: v,
                                    });
                                  }
                                }
                              }}
                              value={
                                Number(
                                  this.state
                                    .selectedOrderLineUnitPriceWithoutTax,
                                ) * Number(this.state.selectedqty)
                              }
                            />
                          )}
                        </Col>
                      ) : (
                        <Col span={3}>
                          {JSON.parse(localStorage.getItem("isInclusiveTax"))
                            ? Number(this.state.selectedOrderLineUnitPrice) *
                              Number(this.state.selectedqty)
                            : Number(
                                this.state.selectedOrderLineUnitPriceWithoutTax,
                              ) * Number(this.state.selectedqty)}
                        </Col>
                      )}
                      {/* <Col span={4}>
                        <Button
                          onClick={() => this.setState({ modalType: "remove" })}
                          style={{ background: "#cc0000", color: "#fff" }}
                        >
                          {" "}
                          Remove{" "}
                        </Button>
                      </Col> */}
                      <Col span={4}>
                        <Popover
                          content={
                            <div className="cancelItempopOver">
                              <li
                                onClick={() =>
                                  this.cancelOrderItem(
                                    this.props.posProductsLists.filter(
                                      (i) =>
                                        i.id === this.state.selectedOrderLine,
                                    ),
                                    true,
                                  )
                                }
                              >
                                {this.props.lang.LABELS.CANCEL_ITEM_DONOT_LOSS_}
                              </li>
                              <li
                                onClick={() =>
                                  this.cancelOrderItem(
                                    this.props.posProductsLists.filter(
                                      (i) =>
                                        i.id === this.state.selectedOrderLine,
                                    ),
                                    false,
                                  )
                                }
                              >
                                {this.props.lang.LABELS.CANCEL_ITEM_LOSS}
                              </li>
                            </div>
                          }
                          title={this.props.lang.LABELS.CANCEL_ITEM_POPOVER}
                          trigger="click"
                          visible={this.state.popoverVisible}
                        >
                          <Button
                            onClick={() => {
                              if (
                                this.props.posProductsLists.filter(
                                  (i) => i.id === this.state.selectedOrderLine,
                                )[0].status == "K"
                              ) {
                                this.setState({ popoverVisible: true });
                              } else {
                                this.cancelOrderItem(
                                  this.props.posProductsLists.filter(
                                    (i) =>
                                      i.id === this.state.selectedOrderLine,
                                  ),
                                  true,
                                );
                              }
                            }}
                            style={{ background: "#cc0000", color: "#fff" }}
                          >
                            {this.props.lang.BUTTON.CANCEL}
                          </Button>
                        </Popover>
                      </Col>
                      <Col span={4}>
                        <Button
                          onClick={() => {
                            this.setState({
                              notesForKitchen:
                                this.props.posProductsLists.filter(
                                  (i) =>
                                    i.product ==
                                      this.state.selectedOrderLineProduct &&
                                    i.id == this.state.selectedOrderLine,
                                ).length > 0 &&
                                this.props.posProductsLists.filter(
                                  (i) =>
                                    i.product ==
                                      this.state.selectedOrderLineProduct &&
                                    i.id == this.state.selectedOrderLine,
                                )[0].notes,
                              itemSelectedForNotesKitchen: this.props.posProductsLists.filter(
                                (i) =>
                                  i.product ==
                                    this.state.selectedOrderLineProduct &&
                                  i.id == this.state.selectedOrderLine,
                              )[0],
                              isModalOpenForKitchenNotes: true,
                            });
                          }}
                        >
                          Add +
                        </Button>
                      </Col>
                    </Row>
                  )}
                <Row gutter={24}>
                  <Col span={24}></Col>
                </Row>
                {/* <h2>
                  {this.state.isGroupProduct
                    ? "Group Items"
                    : "Add on Products"}
                </h2> */}
                {/* @TABLE */}
                {this.state.additionalProduct.length > 0 &&
                  this.state.additionalProduct.map((item, i) => (
                    <div className="subwrapper">
                      <div>
                        <Checkbox
                          value={item.id}
                          key={i}
                          onChange={(e) =>
                            this.addRemoAddProduct(
                              e,
                              item,
                              "",
                              this.props.posProductsLists
                                .filter(
                                  (pro) =>
                                    pro.isAddProduct == true ||
                                    pro.isGroupItem == true,
                                )
                                .filter(
                                  (ii) =>
                                    ii.parentProduct ==
                                    this.state.selectedOrderLine,
                                )
                                .filter(
                                  (it) =>
                                    it.product == item.id &&
                                    it.uom == item.uomId,
                                ),
                              {
                                min:
                                  this.props.productList.length > 0 &&
                                  this.props.productList.filter(
                                    (i) =>
                                      i.id ==
                                        this.state.selectedOrderLineProduct &&
                                      i.isGroupProduct,
                                  ).length > 0 &&
                                  this.props.productList.filter(
                                    (i) =>
                                      i.id ==
                                        this.state.selectedOrderLineProduct &&
                                      i.isGroupProduct,
                                  )[0].minItemQty,
                                max:
                                  this.props.productList.length > 0 &&
                                  this.props.productList.filter(
                                    (i) =>
                                      i.id ==
                                        this.state.selectedOrderLineProduct &&
                                      i.isGroupProduct,
                                  ).length > 0 &&
                                  this.props.productList.filter(
                                    (i) =>
                                      i.id ==
                                        this.state.selectedOrderLineProduct &&
                                      i.isGroupProduct,
                                  )[0].maxItemQty,
                                isGroupProduct:
                                  this.props.productList.length > 0 &&
                                  this.props.productList.filter(
                                    (i) =>
                                      i.id ==
                                        this.state.selectedOrderLineProduct &&
                                      i.isGroupProduct,
                                  ).length > 0 &&
                                  true,
                                items: this.props.posProductsLists,
                                add: true,
                              },
                            )
                          }
                          checked={
                            this.props.posProductsLists
                              .filter(
                                (pro) =>
                                  pro.isAddProduct == true ||
                                  pro.isGroupItem == true,
                              )
                              .filter(
                                (ii) =>
                                  ii.parentProduct ==
                                  this.state.selectedOrderLine,
                              )
                              .filter(
                                (it) =>
                                  it.product == item.id && it.uom == item.uomId,
                              ).length > 0
                              ? true
                              : false
                          }
                        ></Checkbox>
                      </div>

                      <div className="name">
                        <p>
                          {localStorage.getItem("lang") == "EN"
                            ? item.name
                            : item.nameAr}
                        </p>
                      </div>

                      <div>
                        <p>
                          {item.isOffer
                            ? item.offerPrice
                            : JSON.parse(localStorage.getItem("isInclusiveTax"))
                            ? item.price
                            : item.priceWithoutTax}
                        </p>
                      </div>

                      <div>
                        {this.props.posProductsLists
                          .filter(
                            (pro) =>
                              pro.isAddProduct == true ||
                              pro.isGroupItem == true,
                          )
                          .filter(
                            (ii) =>
                              ii.parentProduct == this.state.selectedOrderLine,
                          )
                          .filter(
                            (it) =>
                              it.product == item.id && it.uom == item.uomId,
                          ).length > 0 && (
                          <span style={{ display: "flex" }}>
                            <Button
                              style={{
                                color: "#008000",
                                borderColor: "#008000",
                              }}
                              onClick={() =>
                                this.props.productList.length > 0 &&
                                this.props.productList.filter(
                                  (i) =>
                                    i.id == this.state.selectedOrderLineProduct,
                                ).length > 0 &&
                                !this.props.productList.filter(
                                  (i) =>
                                    i.id == this.state.selectedOrderLineProduct,
                                )[0].isGroupProduct &&
                                this.addRemoAddProduct(
                                  { target: { checked: false } },
                                  item,
                                  this.props.posProductsLists
                                    .filter(
                                      (pro) =>
                                        pro.isAddProduct == true ||
                                        pro.isGroupItem == true,
                                    )
                                    .filter(
                                      (ii) =>
                                        ii.parentProduct ==
                                        this.state.selectedOrderLine,
                                    )
                                    .filter(
                                      (it) =>
                                        it.product == item.id &&
                                        it.uom == item.uomId,
                                    )[0].qty + 1,
                                  this.props.posProductsLists
                                    .filter(
                                      (pro) =>
                                        pro.isAddProduct == true ||
                                        pro.isGroupItem == true,
                                    )
                                    .filter(
                                      (ii) =>
                                        ii.parentProduct ==
                                        this.state.selectedOrderLine,
                                    )
                                    .filter(
                                      (it) =>
                                        it.product == item.id &&
                                        it.uom == item.uomId,
                                    ),
                                  {
                                    min:
                                      this.props.productList.length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                            this.state
                                              .selectedOrderLineProduct &&
                                          i.isGroupProduct,
                                      ).length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                            this.state
                                              .selectedOrderLineProduct &&
                                          i.isGroupProduct,
                                      )[0].minItemQty,
                                    max:
                                      this.props.productList.length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                            this.state
                                              .selectedOrderLineProduct &&
                                          i.isGroupProduct,
                                      ).length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                            this.state
                                              .selectedOrderLineProduct &&
                                          i.isGroupProduct,
                                      )[0].maxItemQty,
                                    isGroupProduct:
                                      this.props.productList.length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                            this.state
                                              .selectedOrderLineProduct &&
                                          i.isGroupProduct,
                                      ).length > 0 &&
                                      true,
                                    items: this.props.posProductsLists,
                                    add: true,
                                  },
                                )
                              }
                            >
                              +
                            </Button>
                            <p style={{ padding: "4px 9px", height: "32px" }}>
                              {
                                this.props.posProductsLists
                                  .filter(
                                    (pro) =>
                                      pro.isAddProduct == true ||
                                      pro.isGroupItem == true,
                                  )
                                  .filter(
                                    (ii) =>
                                      ii.parentProduct ==
                                      this.state.selectedOrderLine,
                                  )
                                  .filter(
                                    (it) =>
                                      it.product == item.id &&
                                      it.uom == item.uomId,
                                  )[0].qty
                              }
                            </p>
                            <Button
                              style={{
                                color: "#008000",
                                borderColor: "#008000",
                              }}
                              onClick={() =>
                                this.props.productList.length > 0 &&
                                this.props.productList.filter(
                                  (i) =>
                                    i.id == this.state.selectedOrderLineProduct,
                                ).length > 0 &&
                                !this.props.productList.filter(
                                  (i) =>
                                    i.id == this.state.selectedOrderLineProduct,
                                )[0].isGroupProduct &&
                                this.addRemoAddProduct(
                                  { target: { checked: false } },
                                  item,
                                  this.props.posProductsLists
                                    .filter(
                                      (pro) =>
                                        pro.isAddProduct == true ||
                                        pro.isGroupItem == true,
                                    )
                                    .filter(
                                      (ii) =>
                                        ii.parentProduct ==
                                        this.state.selectedOrderLine,
                                    )
                                    .filter(
                                      (it) =>
                                        it.product == item.id &&
                                        it.uom == item.uomId,
                                    )[0].qty - 1,
                                  this.props.posProductsLists
                                    .filter(
                                      (pro) =>
                                        pro.isAddProduct == true ||
                                        pro.isGroupItem == true,
                                    )
                                    .filter(
                                      (ii) =>
                                        ii.parentProduct ==
                                        this.state.selectedOrderLine,
                                    )
                                    .filter(
                                      (it) =>
                                        it.product == item.id &&
                                        it.uom == item.uomId,
                                    ),
                                  {
                                    min:
                                      this.props.productList.length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                            this.state
                                              .selectedOrderLineProduct &&
                                          i.isGroupProduct,
                                      ).length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                            this.state
                                              .selectedOrderLineProduct &&
                                          i.isGroupProduct,
                                      )[0].minItemQty,
                                    max:
                                      this.props.productList.length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                            this.state
                                              .selectedOrderLineProduct &&
                                          i.isGroupProduct,
                                      ).length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                            this.state
                                              .selectedOrderLineProduct &&
                                          i.isGroupProduct,
                                      )[0].maxItemQty,
                                    isGroupProduct:
                                      this.props.productList.length > 0 &&
                                      this.props.productList.filter(
                                        (i) =>
                                          i.id ==
                                            this.state
                                              .selectedOrderLineProduct &&
                                          i.isGroupProduct,
                                      ).length > 0 &&
                                      true,
                                    items: this.props.posProductsLists,
                                    add: false,
                                  },
                                )
                              }
                            >
                              -
                            </Button>
                          </span>
                        )}
                        {this.props.posProductsLists
                          .filter((pro) => pro.isAddProduct == true)
                          .filter(
                            (ii) =>
                              ii.parentProduct ==
                              this.state.selectedOrderLineProduct,
                          )
                          .filter(
                            (it) =>
                              it.product == item.id && it.uom == item.uomId,
                          ).length > 0 && (
                          <InputNumber
                            onChange={(v) =>
                              this.addRemoAddProduct(
                                { target: { checked: false } },
                                item,
                                v,
                                this.props.posProductsLists
                                  .filter((pro) => pro.isAddProduct == true)
                                  .filter(
                                    (ii) =>
                                      ii.parentProduct ==
                                      this.state.selectedOrderLineProduct,
                                  )
                                  .filter(
                                    (it) =>
                                      it.product == item.id &&
                                      it.uom == item.uomId,
                                  ),
                              )
                            }
                            value={
                              this.props.posProductsLists
                                .filter((pro) => pro.isAddProduct == true)
                                .filter(
                                  (ii) =>
                                    ii.parentProduct ==
                                    this.state.selectedOrderLineProduct,
                                )
                                .filter(
                                  (it) =>
                                    it.product == item.id &&
                                    it.uom == item.uomId,
                                )[0].qty
                            }
                          />
                        )}
                      </div>
                      <div>
                        {this.props.posProductsLists
                          .filter(
                            (pro) =>
                              pro.isAddProduct == true ||
                              pro.isGroupItem == true,
                          )
                          .filter(
                            (ii) =>
                              ii.parentProduct == this.state.selectedOrderLine,
                          )
                          .filter(
                            (it) =>
                              it.product == item.id && it.uom == item.uomId,
                          ).length > 0 && (
                          <td
                            style={{ marginRight: "0px", marginLeft: "60px" }}
                          >
                            {JSON.parse(localStorage.getItem("isInclusiveTax"))
                              ? this.props.posProductsLists
                                  .filter(
                                    (pro) =>
                                      pro.isAddProduct == true ||
                                      pro.isGroupItem == true,
                                  )
                                  .filter(
                                    (ii) =>
                                      ii.parentProduct ==
                                      this.state.selectedOrderLine,
                                  )
                                  .filter(
                                    (it) =>
                                      it.product == item.id &&
                                      it.uom == item.uomId,
                                  )[0].totalNetLine
                              : this.props.posProductsLists
                                  .filter(
                                    (pro) =>
                                      pro.isAddProduct == true ||
                                      pro.isGroupItem == true,
                                  )
                                  .filter(
                                    (ii) =>
                                      ii.parentProduct ==
                                      this.state.selectedOrderLine,
                                  )
                                  .filter(
                                    (it) =>
                                      it.product == item.id &&
                                      it.uom == item.uomId,
                                  )[0].netLineWithoutTax}
                          </td>
                        )}
                      </div>

                      <div>
                        {this.props.posProductsLists
                          .filter(
                            (pro) =>
                              pro.isAddProduct == true ||
                              pro.isGroupItem == true,
                          )
                          .filter(
                            (ii) =>
                              ii.parentProduct == this.state.selectedOrderLine,
                          )
                          .filter(
                            (it) =>
                              it.product == item.id && it.uom == item.uomId,
                          ).length > 0 && (
                          <td>
                            <div className="imagewrap2">
                              <img
                                src="/icons/note.png"
                                onClick={() => {
                                  this.state.addedAdditionalItems.length > 0 &&
                                    this.state.addedAdditionalItems.filter(
                                      (pro) =>
                                        pro.isAddProduct == true ||
                                        pro.isGroupItem == true,
                                    ).length > 0 &&
                                    this.state.addedAdditionalItems
                                      .filter(
                                        (pro) =>
                                          pro.isAddProduct == true ||
                                          pro.isGroupItem == true,
                                      )
                                      .filter(
                                        (ii) =>
                                          ii.parentProduct ==
                                          this.state.selectedOrderLine,
                                      ).length > 0 &&
                                    this.setState({
                                      notesForKitchen: null,
                                      itemSelectedForNotesKitchen: item.id,
                                      isNotesAddedOnCreate: true,
                                      isModalOpenForKitchenNotes: true,
                                    });
                                }}
                              />
                            </div>
                          </td>
                        )}
                      </div>
                    </div>
                  ))}
              </React.Fragment>
            ) : (
              ""
            )}
          </Modal>
        )}

        {/* Combo Deatail Modal Code Here */}

        <Modal
          className="posAddItemModal product-modal-pop topography sadi2"
          // title={this.props.lang.TABLEHEADERS.COMBO_PRODUCTS}
          visible={this.state.comboProductsModal}
          onCancel={() => {
            // if (this.state.combo.comboLines.length > 0) {
            //   message.error(
            //     this.props.lang.MESSAGES.CLOSE_PRODUCTADDMODAL_ERROR
            //   );
            // } else {
            //   this.setState({ comboProductsModal: false });
            // }
            this.setState({ comboProductsModal: false });
          }}
          onOk={() => this.handleComboProductsOnOk()}
          style={{ direction: this.props.lang.INJAZ_AUTH_DIRECTION }}
          okText={this.props.lang.OK}
          cancelText={this.props.lang.CANCEL}
        >
          <div className="customwrappercombo">
            <div className="cartheader">
              <div className="txt">{this.state.combo.name}</div>

              <div
                className="image"
                style={{
                  background:
                    this.state.combo.imageName != null
                      ? `url(${API_URL}getProductImage?clientName=${localStorage.getItem(
                          "client_name",
                        )}&imageName=${
                          this.state.combo.imageName
                        }&imageContent=${imageContent})`
                      : "#c3c1c1",
                }}
              ></div>
              <div className="txt">{this.state.combo.nameAr}</div>
            </div>
            {/* setisactive */}
            <div
              className="toppinglisting"
              style={{
                gridTemplateColumns: `repeat(${this.props.comboDetailOption.length}, minmax(145px, 1fr))`,
              }}
            >
              {/* {console.log(this.props.comboDetailOption, 'asdasdasdasdsad')} */}
              {this.props.comboDetailOption.length > 0 &&
                this.props.comboDetailOption.map((item, index) => {
                  return (
                    <div
                      key={index}
                      onClick={() => {
                        this.setState({
                          setmapindex: index,
                          setisactive: index,
                        });
                      }}
                      className="indiitem"
                      style={{
                        border: `1px solid ${
                          this.state.setisactive == index
                            ? "var(--cr-primary"
                            : "transparent"
                        }`,
                        background:
                          this.state.setisactive == index
                            ? "rgb(28 28 28)"
                            : "",
                        color:
                          this.state.setisactive == index
                            ? "var(--cr-primary) !important"
                            : "",
                      }}
                    >
                      <p>{item.header}</p>
                      {/* {console.log(this.state.setmapindex, 'sadadasd')} */}
                    </div>
                  );
                })}
            </div>

            <div className="conditionalmapdata">
              {this.props.comboDetailOption.length > 0 &&
                this.props.comboDetailOption.map((item, key) => {
                  if (key == this.state.setmapindex) {
                    return (
                      <div className="conditionalmapdata">
                        <div className="selecteditem">
                          <div className="hedi">
                            <p>{item.header}</p>
                          </div>
                          <div className="hedi">
                            <p>Min {item.minProduct}</p>
                          </div>
                          <div className="hedi">
                            <p>Max {item.maxProduct}</p>
                          </div>
                        </div>
                        {item.products.map((inneritem) => {
                          return (
                            <div className="selecteditem">
                              <Checkbox
                                value={inneritem.id}
                                key={inneritem.id}
                                onChange={(e) =>
                                  this.selectComboProduct(inneritem, e, item)
                                }
                                checked={
                                  this.state.combo.comboLines
                                    ? this.state.combo.comboLines.length > 0
                                      ? this.state.combo.comboLines.filter(
                                          (i) => i.id == inneritem.id,
                                        ).length > 0
                                        ? true
                                        : false
                                      : false
                                    : false
                                }
                              ></Checkbox>
                              <div span="11">
                                <p>{inneritem.productName}</p>
                              </div>
                              <div span="8">
                                <p>SAR {inneritem.salesPriceTax}</p>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    );
                  }
                })}
            </div>
          </div>
        </Modal>

        {/* Combo Update Deatail Modal Code Here */}

        <Modal
          className="posAddItemModal product-modal-pop sadi3"
          title={"Combo Products Update"}
          visible={this.state.comboProductsModalUpdate}
          onCancel={() => {
            this.setState({ comboProductsModalUpdate: false });
          }}
          onOk={() => this.handleComboProductsUpdateOnOk()}
          style={{ direction: this.props.lang.INJAZ_AUTH_DIRECTION }}
          okText={this.props.lang.OK}
          cancelText={this.props.lang.CANCEL}
        >
          <div className="comboModalsRows">
            <h3>{this.state.combo.name}</h3>
            <div className="contetn">
              <div>
                <span style={{ display: "flex" }}>
                  <Button
                    onClick={(e) => {
                      let combo = { ...this.state.combo };
                      combo.qty = combo.qty + 1;
                      this.setState({ combo });
                    }}
                  >
                    +
                  </Button>
                  <p className="amount">{this.state.combo.qty}</p>
                  <Button
                    onClick={() => {
                      let combo = { ...this.state.combo };
                      combo.qty = combo.qty - 1;
                      this.setState({ combo });
                    }}
                  >
                    -
                  </Button>
                </span>
              </div>
              <div className="price">
                SAR {this.state.combo.total * this.state.combo.qty}
              </div>
              <div>
                <Button onClick={() => this.deleteSaleOrderLineCombo()}>
                  {" "}
                  Remove{" "}
                </Button>
              </div>
            </div>
          </div>

          {this.state.comboDetailOptionForUpdate.length > 0 &&
            this.state.comboDetailOptionForUpdate.map((item) => (
              <Row className="comboModalsRows">
                <div className="head">
                  <div>
                    <h3>{item.header}</h3>
                  </div>
                  <div>
                    <p>Min{"     " + item.minProduct}</p>
                  </div>
                  <div>
                    <p>Max{"     " + item.maxProduct}</p>
                  </div>
                </div>
                <div className="row">
                  <div></div>
                  <div>{/* <b>Product Name</b> */}</div>
                  <div>{/* <b>Product Price</b> */}</div>
                </div>
                {item.products.length > 0 &&
                  item.products.map((product) => (
                    <div className="row">
                      <div>
                        <Checkbox
                          value={product.productId}
                          key={product.id}
                          onChange={(e) =>
                            this.selectComboProductUpdate(product, e, item)
                          }
                          checked={
                            this.state.combo.comboLines
                              ? this.state.combo.comboLines.length > 0
                                ? this.state.combo.comboLines.filter(
                                    (i) => i.product == product.productId,
                                  ).length > 0
                                  ? true
                                  : false
                                : false
                              : false
                          }
                        ></Checkbox>
                      </div>
                      <div>{product.productName}</div>
                      <div>SAR {product.salesPriceTax}</div>
                    </div>
                  ))}
              </Row>
            ))}
        </Modal>

        {this.state.refunModal && (
          <Modal
            title={this.props.lang.TABLEHEADERS.REFUND_PRODUCTS}
            visible={this.state.refunModal}
            onCancel={() => this.setState({ refunModal: false })}
            onOk={() => this.refunModalHandler(this.state.refundObject)}
            style={{ direction: this.props.lang.INJAZ_AUTH_DIRECTION }}
            okText={this.props.lang.OK}
            cancelText={this.props.lang.CANCEL}
          >
            <Row gutter={12}>
              <Col span={6}>
                <Form.Item label={this.props.lang.LABELS.PNAME}>
                  {this.state.refundObject.isCombo == true
                    ? this.state.combosList.length > 0 &&
                      this.state.combosList.filter(
                        (prod) => prod.id == this.state.refundObject.combo,
                      ).length > 0 &&
                      this.state.combosList.filter(
                        (prod) => prod.id == this.state.refundObject.combo,
                      )[0].name
                    : this.state.productsListByClient.length > 0 &&
                      this.state.productsListByClient.filter(
                        (prod) => prod.id == this.state.refundObject.product,
                      ).length > 0 &&
                      this.state.productsListByClient.filter(
                        (prod) => prod.id == this.state.refundObject.product,
                      )[0].name}
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label={this.props.lang.LABELS.PPRICE}>
                  {JSON.parse(localStorage.getItem("isInclusiveTax"))
                    ? this.state.refundObject.unitPrice
                    : this.state.refundObject.priceWithoutTax}
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label={this.props.lang.LABELS.REFUND_QTY}>
                  <InputNumber
                    defaultValue={0}
                    onChange={(v) => this.setState({ refundQTY: v })}
                    min={0}
                    max={parseInt(parseInt(this.state.refundObject.qty))}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Modal>
        )}
        {this.state.qtyCalculator && (
          <Modal
            title={this.props.lang.LABELS.ENTER_QTY}
            visible={this.state.qtyCalculator}
            onCancel={() => this.setState({ qtyCalculator: false })}
            onOk={() => this.qtyCalculatorHandler()}
            footer={false}
            style={{ direction: this.props.lang.INJAZ_AUTH_DIRECTION }}
            okText={this.props.lang.OK}
            cancelText={this.props.lang.CANCEL}
          >
            <Card
              style={{ maxHeight: "100vh" }}
              title={
                <div style={{ height: "200%" }}>
                  <h2 style={{ textAlign: "center" }}>
                    {this.state.amountPay}
                  </h2>
                </div>
              }
            >
              <div style={{ width: "100%", height: "70%", margin: "0 auto" }}>
                <div
                  style={{
                    width: "100%",
                    height: "54px",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div
                    className="posButton  calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                    }}
                    onClick={() => this.calculatorFunction(1)}
                  >
                    1
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                    }}
                    onClick={() => this.calculatorFunction(2)}
                  >
                    2
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() => this.calculatorFunction(3)}
                  >
                    3
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    height: "54px",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      height: "54px",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                      borderTop: "none",
                    }}
                    onClick={() => this.calculatorFunction(4)}
                  >
                    4
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      borderTop: "none",
                      width: "100%",
                      height: "54px",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                    }}
                    onClick={() => this.calculatorFunction(5)}
                  >
                    5
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      borderTop: "none",
                      width: "100%",
                      height: "54px",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() => this.calculatorFunction(6)}
                  >
                    6
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    height: "54px",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      height: "54px",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                      borderTop: "none",
                    }}
                    onClick={() => this.calculatorFunction(7)}
                  >
                    7
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      borderTop: "none",
                      width: "100%",
                      height: "54px",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                    }}
                    onClick={() => this.calculatorFunction(8)}
                  >
                    8
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      borderTop: "none",
                      width: "100%",
                      height: "54px",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() => this.calculatorFunction(9)}
                  >
                    9
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    height: "54px",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      height: "54px",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                      borderTop: "none",
                    }}
                    onClick={() => this.calculatorFunction("c")}
                  >
                    C
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      borderTop: "none",
                      width: "100%",
                      height: "54px",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                    }}
                    onClick={() => this.calculatorFunction(0)}
                  >
                    0
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      borderTop: "none",
                      width: "100%",
                      height: "54px",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() => this.calculatorFunction("b")}
                  >
                    <Icon type="close" />
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    height: "54px",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      flexGrow: 1,
                      flexShrink: 2,
                      height: "54px",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                      borderTop: "none",
                    }}
                    onClick={() => this.calculatorFunction(".")}
                  >
                    .
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      flexGrow: 2,
                      height: "54px",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                      borderTop: "none",
                    }}
                    onClick={() => this.calculatorFunction("e")}
                  >
                    ENTER
                  </div>
                </div>
              </div>
            </Card>
          </Modal>
        )}
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    posStorage: state.posStorage,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(Poslip);
